import _ from 'lodash';
// scm项目无jq需改造，在pre-init里挂载
const init = () => {
    let RC = window.RayCloud || {};
    let util = RC.util || {};

    RC.tools = util.tools = {
        pickPicPath(data, packPicShowType) {
            let { platformPicPath = '', sysPicPath = '' } = data;
            if (packPicShowType === 0) {
                // 优先系统图片
                if (!sysPicPath || sysPicPath.indexOf('no_pic') > -1) {
                    return platformPicPath;
                }
                return sysPicPath;
            } else {
                // 优先平台图片
                if (!platformPicPath || platformPicPath.indexOf('no_pic') > -1) {
                    return sysPicPath;
                }
                return platformPicPath;
            }
        },
        isEmptyObj: function(obj) {
            obj = obj || {};
            for (var key in obj) {
                return false;
            }
            return true;
        },
        //字母或数字
        isNumOrLatter: function(str){
            var patrn = /^[0-9a-zA-Z]*$/g;
            return patrn.test(str);
        },
        isNum: function(num) {
            return /^([+-]?)\d*\.?\d+$/.test(num);
        },
        // 正整数
        isPositiveInt: function(num) {
            var reg = /^[1-9]*[1-9][0-9]*$/;
            return reg.test(num);
        },
        // 非负整数，包括0
        isNonNegativeInt: function(num) {
            var reg = /^([1-9]*[1-9][0-9]*)|^0$/;
            return reg.test(num);
        },
        // 非负浮点数，如金额
        isNonNegativeDouble: function(num) {
            var reg = /^([1-9]\d*\.?\d*|0\.\d*[1-9]\d*|0?\.0+|0)$/;
            return reg.test(num);
        },
        isNullOrUndefined: function(val) {
            return (val === null || val === '' || typeof (val) === 'undefined' || val === 'undefined' || val === 'null');
        },
        /**
         * 手机校验
         * @param  {[type]}  val [description]
         * @return {Boolean}     [description]
         */
        isMobile: function(val) {
            return /^0?1[0-9]+[0-9]{9}$/.test(val);
        },
        /**
         * 邮编校验
         * @param  {[type]}  val [description]
         * @return {Boolean}     [description]
         */
        isZip: function(val) {
            return /^\d{6}$/.test(val);
        },
        /**
         * 固话校验
         * @param  {[type]}  val [description]
         * @return {Boolean}     [description]
         */
        isPhone: function(val) {
            return /^[0-9-\+()（） ]{7,18}$/.test(val);
        },
        /**
         * 邮箱校验
         * @param  {[type]}  val [description]
         * @return {Boolean}     [description]
         */
        isEmail: function(val) {
            return /\w+((-w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+/.test(val);
        },
        // 处理undefined
        handleAttrData: function(data) {
            return typeof data === 'undefined' ? '' : data;
        },
        // 浮点数相加
        numAdd(arg1, arg2){
            var r1, r2, m;
            try { r1 = arg1.toString().split(".")[1].length; } catch (e) { r1 = 0; }
            try { r2 = arg2.toString().split(".")[1].length; } catch (e) { r2 = 0; }
            m = Math.pow(10, Math.max(r1, r2));
            return (arg1 * m + arg2 * m) / m;
        },
        // 浮点数相减
        numSubtract(arg1, arg2) {
            var r1, r2, m, n;
            try { r1 = arg1.toString().split(".")[1].length; } catch (e) { r1 = 0; }
            try { r2 = arg2.toString().split(".")[1].length; } catch (e) { r2 = 0; }
            m = Math.pow(10, Math.max(r1, r2));
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m) / m).toFixed(n);
        },
        // 浮点数相乘
        numMultiply(arg1, arg2) {
            var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
            try { m += s1.split(".")[1].length; } catch (e) {}
            try { m += s2.split(".")[1].length; } catch (e) {}
            return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
        },
        // 浮点数相除
        numDivide(arg1, arg2){
            var t1=0,t2=0,r1,r2;
            try{ t1=arg1.toString().split(".")[1].length; }catch(e){}
            try{ t2=arg2.toString().split(".")[1].length; }catch(e){}
            r1 = Number(arg1.toString().replace(".",""));
            r2 = Number(arg2.toString().replace(".",""));
            return (r1/r2)*Math.pow(10,t2-t1);
        },
        // 除以100，保留两位小数
        divide100_fixed2: function(value) {
            value = value || 0;
            if (!util.tools.isNum(value)) {
                return value;
            }
            return parseFloat(value / 100).toFixed(2);
        },
        // 除以100，保留两位小数
        divide100_fixed3: function(value) {
            value = value || 0;
            if (!util.tools.isNum(value)) {
                return value;
            }
            return parseFloat(value / 100).toFixed(3);
        },
        // 除以100，保留n位小数
        divide100_fixed: function(value) {
            const amountDigits = RC.user.get().amountDigits;
            value = value || 0;
            if (!util.tools.isNum(value)) {
                return value;
            }
            return parseFloat(value / 100).toFixed(amountDigits);
        },
        amountDigits() {
            return _globel_vm.$store.getters.erpUserInfo?.amountDigits;
        },
        fixedFormat(format, key = '#') {
            const digitNum = RC.tools.amountDigits();
            const temp = Array.from({ length: +digitNum }).reduce((sum) => sum += `${key}`, '');
            return `${format}.${temp}`;
        },
        // 根据系统通用配置，保留 n 位小数，默认取配置项
        toFixedN(value, num) {
            if (!util.tools.isNum(value)) return value;
            const digit = num || RC.tools.amountDigits() || 3;
            const tempValue = _.round(Math.abs(value), digit);
            return (value < 0 ? '-' : '') + Number.parseFloat(tempValue).toFixed(digit);
        },
        // 阻止冒泡
        preventDefaultBubble: function(e) {
            var event = e || window.event;
            if (event && event.stopPropagation) {
                event.stopPropagation();
            } else {
                event.cancelBubble = true;
            }
        },
        // 获取选中文字
        getSelectedText: function() {
            if (window.getSelection) {
                return window.getSelection().toString();
            } else {
                return document.selection.createRange().text;
            }
        },
        setHash: function(params){
            params = params || {};
            var crtHashs = $.extend(RC.pages._fn_act_get_hashs(), params);
            delete crtHashs.root;
            delete crtHashs.app;
            RC.pages.setCurHash(crtHashs);
        },
        /**
         * 格式化输入
         * @param  {[type]} $container [description]
         */
        handleFormatInput: function($container) {
            RC.controls.get('control.util.number_format').init({
                container: $container
            });
            $container.on('focus', '.rc-number-control', function() {
                $(this).select();
            });
        },
        /**
         * iTip
         * @param  {[type]} $container [description]
         * @param  {[type]} opts [description]
         */
        handleTip: function($container, opts) {
            $container.find('.j-tip').each(function() {
                if ($(this).text() || $(this).attr('data-title')) {
                    $(this).iTip('destroy');
                    $(this).iTip($.extend({
                        skin: 'blue',
                        triggerType: 'hover'
                    }, opts));
                }
            });
        },
        /**
         * 计算序号
         * @param  {[type]} $listBody [description]
         * @param  {[type]} selector  [description]
         */
        renderIndex: function($listBody, selector) {
            selector = selector || '.a-index';
            $listBody.find(selector).each(function(i) {
                $(this).text(i + 1);
            });
        },
        /**
         * 通过更改hash实现分页
         * @param  {[type]} $pageBar    [description]
         * @param  {[type]} getParamsFn [获取参数的方法]
         */
        _event_bind_change_page: function($pageBar, getParamsFn) {
            // 改变显示数量
            $pageBar.on('change', 'select', function(e){
                RC.pages.modifyCurHash($.extend(getParamsFn(), {
                    pageNo: 1,
                    pageSize: $(this).val()
                }), true);
            });

            // 前一页, 后一页
            $pageBar.on('click', '.m-pages-prev, .m-pages-next', function(e){
                var pageNo = $(this).data('page');
                if (util.tools.isPositiveInt(pageNo)) {
                    RC.pages.modifyCurHash($.extend(getParamsFn(), { pageNo: pageNo }), true);
                }
            });

            // 跳转
            $pageBar.on('click', '.m-pages-btn', function(e){
                var pageSize = $pageBar.find('select').eq(0).val(),
                    switchPageNo = $pageBar.find('input.m-pages-text').val() * 1,
                    total = $pageBar.find('.m-pages-total strong').text() * 1,
                    totalPage = Math.ceil(total / pageSize);
                if (switchPageNo > totalPage) {
                    $.dialog.alert('超出最大页数');
                } else if (util.tools.isPositiveInt(switchPageNo)) {
                    RC.pages.modifyCurHash($.extend(getParamsFn(), { pageNo: switchPageNo }), true);
                } else {
                    $.dialog.alert('页码为正整数！');
                }
            });

            $pageBar.on('focus', 'input', function(){
                this.select();
            });
        },
        // 根据分类返回仓库信息
        getWarehousesByCategory: function(category) {
            var warehouseList = RC.user.get().warehouses,
                result = [];
            if (category) {
                for (var i = 0; i < warehouseList.length; i++) {
                    if (warehouseList[i].category === category) {
                        result.push(warehouseList[i]);
                    }
                }
                return result;
            } else {
                return warehouseList;
            }
        },
        getWarehouseNameById: function(id) {
            var warehouseList = RC.user.get().warehouses,
                obj = {};
            for (var i = 0; i < warehouseList.length; i++) {
                obj[warehouseList[i].id] = warehouseList[i].name;
            }
            return obj[id];
        },
        getWarehouseHtml: function(opts) {
            opts = $.extend({
                dataCache: opts.dataCache || '',
                dataName: 'warehouseId',
                needAll: true,
                needAllText: '全部仓库',
                needAllVal: -1,
                style: opts.style || 'width: 130px;',
                needDefault: false,
                needOtherWarehouses: false, // 默认只有自发仓库
                needWarehouseStores: true, //默认显示门店仓库
                onlyOptions: false // 只要选项
            }, opts || {});

            var warehouses = RC.user.get().warehouses || [],
                selectWrap = opts.onlyOptions ? '' : [
                    '<select',
                    ' data-cache="' + opts.dataCache + '"',
                    ' data-name="' + opts.dataName + '"',
                    this.isNullOrUndefined(opts.zIndex) ? '' : (' data-zindex=' + opts.zIndex),
                    ' style="' + opts.style + '"',
                    '>'
                ].join(''),
                warehouseHtml = [
                    selectWrap,
                    opts.needAll ? ('<option value="' + opts.needAllVal + '">' + opts.needAllText + '</option>') : ''
                ];

            for (var i = 0; i < warehouses.length; i++) {
                warehouseHtml.push([
                    '<option '+((opts.needDefault && warehouses[i].isDefault) ? 'selected' : '')+' value="' + warehouses[i].id + '">' + warehouses[i].name + '</option>'
                ].join(''));
            }

            var warehouseExtras = RC.user.get().warehouseExtras || [],
                warehouseStores = opts.needWarehouseStores ? (RC.user.get().warehouseStores || []): [];
            if(opts.needOtherWarehouses){
                for ( i = 0; i < warehouseExtras.length; i++) {
                    warehouseHtml.push([
                        '<option class="warehouseExtras" value="' + warehouseExtras[i].id + '">' + warehouseExtras[i].name + '</option>'
                    ].join(''));
                }
                for ( i = 0; i < warehouseStores.length; i++) {
                    warehouseHtml.push([
                        '<option class="warehouseStores" value="' + warehouseStores[i].id + '">' + warehouseStores[i].name + '</option>'
                    ].join(''));
                }
            }
            if (!opts.onlyOptions) {
                warehouseHtml.push('</select>');
            }
            return warehouseHtml.join('');
        },
        /**
         * 数组转对象
         * @param  {[type]} list  [description]
         * @param  {[type]} field [description]
         * @return {[type]}       [description]
         */
        listToObj: function(list, field) {
            list = [].concat(list || []);
            var obj = {};
            for (var i = 0; i < list.length; i++) {
                var item = list[i];
                obj[item[field]] = item;
            }
            return obj;
        },
        /**
         * 对象转数组
         * @param  {[type]} obj [description]
         * @return {[type]}     [description]
         */
        objToList: function(obj) {
            obj = obj || {};
            var arr = [];
            for (var key in obj) {
                var item = obj[key];
                if (obj.hasOwnProperty(key)) {
                    arr.push(item);
                }
            }
            return arr;
        },
        /**
         * 前置补零
         * @param  {[type]} oldVal [description]
         * @param  {[type]} len    [长度]
         * @return {[type]}        [补零完的字符串]
         */
        get_val_zero_fill: function(oldVal, len) {
            oldVal = oldVal + '';
            var fillNum = len - oldVal.length,
                newVal = oldVal;
            if (fillNum) {
                for (var i = 0; i < fillNum; i++) {
                    newVal = '0' + newVal;
                }
            }
            return newVal;
        },
        /**
         * 获取00:00:00时间
         * @param  {[Date]} date [时间对象]
         * @param  {[int]} increment [增量天数]
         * @return {[type]} [description]
         */
        getDateStart: function(date, increment) {
            date = date || new Date();
            increment = increment || 0;
            date = new Date(date.getTime() + 24 * 60 * 60 * 1000 * increment);
            return new Date(RC.util.date.getdate(date, 'YY-MM-DD').split('-').join('/'));
        },
        /**
         * 获取23:59:59时间
         * @param  {[Date]} date [时间对象]
         * @param  {[int]} increment [增量天数]
         * @return {[type]} [description]
         */
        getDateEnd: function(date, increment) {
            date = date || new Date();
            increment = increment || 0;
            date = new Date(date.getTime() + 24 * 60 * 60 * 1000 * increment);
            return new Date((new Date(RC.util.date.getdate(date, 'YY-MM-DD').split('-').join('/'))).getTime() + 24 * 60 * 60 * 1000 - 1);
        },
        /**
         * 计算物流已发货时长
         * @param uploadTime 发货时间
         * @returns {string} 已发货时长指从发货到目前共多长时间（单位：M天N时），具体分秒直接忽略；
         */
        getDeliveredTime: function (uploadTime) {
            uploadTime = parseInt(uploadTime / 1000, 10);
            var now = parseInt(new Date().getTime() / 1000, 10),
                sendTime = now - uploadTime,
                oneDaySec = 60 * 60 * 24,
                day = 0,
                hour = 0;
            day = parseInt((sendTime / oneDaySec), 10);
            hour = parseInt((sendTime % oneDaySec) / 60 / 60, 10);
            return  (isNaN(day) ? '-' : day) + '天' + (isNaN(hour) ? '-' : hour) + '时';
        },
        /**
         * 设置弹框位置
         * @param {[type]} handler [弹窗句柄]
         * @param {string} leftPercent [description]
         * @param {string} rightPercent [description]
         */
        setDialogPosition: function(handler, leftPercent, rightPercent) {
            handler && handler.position instanceof Function && handler.position(leftPercent || handler._left, rightPercent || handler._top);
        },
        /**
         * 是否特殊限制公司
         * @return {Boolean} [description]
         */
        is_spec_limit_company: function() {
            var companyIdSet = {
                1184: true,
                925: true
            };
            return !!companyIdSet[RC.user.get().companyId];
        },
        showErrors: function(errorList, colNameObj, mapObj, opts, boolmsg){
            colNameObj = $.extend({
                col1: '序号',
                col2: '提示信息'
            }, colNameObj);
            mapObj = mapObj || {
                id: 'id',
                detail: 'detail'
            };
            opts = $.extend({
                title: '校验结果',
                okFn: function(){},
                closeFn: function(){}
            }, opts);
            errorList = errorList || [];

            var errorRows = [];
            for (var i = 0; i < errorList.length; i++) {
                var item = errorList[i];
                errorRows.push([
                    '<tr class="error-row">',
                        opts.index ? `<td style="width: 40px;border-right: 1px solid #eaeaea;">${i + 1}</td>` : '',
                        '<td class="error-id" style="width: 130px">' + util.tools.handleAttrData(item[mapObj.id]) + '</td>',
                        '<td class="error-details">' + util.tools.handleAttrData(item[mapObj.detail]) + '</td>',
                    '</tr>'
                ].join(''));
            }
            $.dialog({
                title: opts.title,
                icon: 'warn.png',
                content: [
                    '<div class="errormsg-table-wrapper">',
                        boolmsg ? `<div style="padding: 8px 0; font-size: 16px;">成功${boolmsg.success}条，失败${boolmsg.error}条，原因如下：</div>` : '',
                        '<div style="overflow: auto;max-height:600px">',
                            '<table class="error-table">',
                                '<tr class="error-row error-head">',
                                    opts.index ? '<td style="width: 40px;border-right: 1px solid #eaeaea;">序号</td>' : '',
                                    '<td class="error-num" style="width: 130px">' + colNameObj.col1 + '</td>',
                                    '<td class="error-details">' + colNameObj.col2 + '</td>',
                                '</tr>',
                                errorRows.join(''),
                            '</table>',
                        '</div>',
                    '</div>'
                ].join(''),
                okVal: '关闭',
                ok: opts.okFn,
                close: opts.closeFn
            });
        },
        /**
         * 失去焦点、发出声音，弹窗警告、确认聚焦
         * @param  {[type]} $blur [description]
         * @param  {[type]} msg   [description]
         * @param  {[type]} opts  [description]
         */
        blurSoundAlertFocus: function($blur, msg, opts) {
            var SoundTip = RC.controls.get('control.common_soundtip');
            msg = msg || '校验失败';
            opts = $.extend({
                // TODO
            }, opts);
            $blur.blur();
            SoundTip.play_error_tip();
            $.dialog.alert(msg, function() {
                $blur.focus();
            });
        },
        // 防抖
        debounce(fn, time) {
            let timeId = null;
            return function () {
                let args = arguments;
                let that = this;
                if (timeId) {
                    clearTimeout(timeId);
                }
                timeId = setTimeout(function () {
                    fn.call(that,...args);
                    timeId = null;
                }, time);
            };
        },
        // 节流
        throttle(fn, time) {
            let timeId = null;
            return function () {
                let args = arguments;
                let that = this;
                if (timeId) {
                    return;
                } else {
                    timeId = setTimeout(function () {
                        fn.call(that,...args);
                        timeId = null;
                    }, time);
                }
            };
        },
        getShopByUserId(userId){
            let shops = _globel_vm.$store.getters['orderAudit/getShopList'] || [];
            for(let i =0;i<shops.length;i++){
                let shop = shops[i];
                if(shop.userId === userId){
                    return shop;
                }
            }
            return null;
        },
        // 按钮权限常量
        BtnPowerConsts: {

            TRADE_SEARCH: 211, // 交易-三个月内订单查询
            TRADE_SEARCH_COPY_NEW_ORDER: 21101, // 交易-三个月内订单查询-复制新建
            TRADE_SEARCH_EXPORT_ORDER: 21102, // 交易-三个月内订单查询-导出订单
            TRADE_SEARCH_EXPORT_ORDER_DETAIL: 21103, // 交易-三个月内订单查询-导出订单明细
            TRADE_SEARCH_EXPORT_SHIPPING: 21110, // 交易-三个月内订单查询-导入实际运费
            TRADE_SEARCH_APPOINT_DOWNLOAD: 21104, // 交易-三个月内订单查询-指定下载
            TRADE_SEARCH_MULTI_VIEW: 21105, // 交易-三个月内订单查询-多快递单查询
            TRADE_SEARCH_PRINT_ORDER: 21121, // 交易-三个月内订单查询-预览/打印
            TRADE_SEARCH_UPDATE_POSTFEE: 21108, // 交易-三个月内订单查询-修改实际运费
            TRADE_SEARCH_DCRY: 21109, // 交易-三个月内订单查询-批量解密
            TRADE_SEARCH_UPDATE_LIST_POSTFEE: 21111, // 交易-三个月内订单列表-修改实际运费
            TRADE_SEARCH_UPDATE_REMARK: 21112, // 交易-三个月内订单列表-修改平台备注
            TRADE_SEARCH_EDIT_CUSTOM_FILTER: 211207, // 交易-三个月内订单查询-自定义过滤条件操作权限
            TRADE_SEARCH_IMPORT_COST: 21113, // 交易-三个月内订单列表-导入成本
            TRADE_SEARCH_ORDER_GOODS_WEIGHT_VOLUME_UPDATE: 211100815, // 交易-三个月内订单列表-订单商品重量/体积更新
            TRADE_SEARCH_IMPORT_SYSNOTE: 21114, // 交易-三个月内订单列表-导入系统备注

            TRADE_HISTORY: 2112, // 交易-三个月前订单
            TRADE_HISTORY_EXPORT_ORDER: 21106, // 交易-三个月前订单-导出订单
            TRADE_HISTORY_EXPORT_ORDER_DETAIL: 21107, // 交易-三个月前订单-导出订单明细

            TRADE_DEAL: 213, // 交易-订单处理
            TRADE_DEAL_PROCESS: 2136, // 交易-订单处理-全部
            TRADE_DEAL_PROCESS_NO_SHIPPING_MARKINGS: 2136099, // 订单管理/处理-批量标记商品无需发货
            TRADE_DEAL_PROCESS_EDIT_SALESMAN: 213008, // 交易-订单处理-全部-修改业务员
            TRADE_DEAL_PROCESS_ADD_DISTRI_PROD: 231230, // 交易-订单处理-全部-新增分销属性
            TRADE_DEAL_PROCESS_CANCEL_DISTRI_PROD: 231231, // 交易-订单处理-全部-取消分销属性
            TRADE_DEAL_PROCESS_FORCE_POINT_VENDOR: 231232, // 交易-订单处理-全部-强制指定供销商
            TRADE_DEAL_PROCESS_DISTRI_PAY: 231233, // 交易-订单处理-全部-分销商付款
            TRADE_DEAL_PROCESS_RETURN_SUPPLAY_ORDER: 231280, // 交易-订单处理-全部-打回供销订单
            TRADE_DEAL_PROCESS_SUPPLY_STOCK_SPLIT: 231300, // 交易-订单处理-全部-供销缺货拆分
            TRADE_DEAL_PROCESS_SUPPLY_MIX_SPLIT: 2131312, // 交易-订单处理-全部-供销混合拆分
            TRADE_DEAL_PROCESS_APPOINT_DOWNLOAD: 213129, // 交易-订单处理-全部-指定下载
            TRADE_DEAL_PROCESS_CLOSE_ORDER: 213125, // 交易-订单处理-全部-全部
            TRADE_DEAL_PROCESS_COPY_NEW_ORDER: 213126, // 交易-订单处理-全部-复制新建
            TRADE_DEAL_PROCESS_BATCH_CANCEL_SPLIT_ORDER: 231316, // 交易-订单处理-全部-批量取消拆单
            TRADE_DEAL_PROCESS_TOAUDIT: 21370, // 交易-订单处理-全部-审核
            TRADE_DEAL_PROCESS_TOUNAUDIT: 21373, // 交易-订单处理-全部-重新审核
            TRADE_DEAL_PROCESS_FINACE_AUDIT: 21371, // 交易-订单处理-全部-财审审核
            TRADE_DEAL_PROCESS_FINACE_REJECT: 21372, // 交易-订单处理-全部-财审拒绝
            TRADE_DEAL_PROCESS_VOID: 213127, // 交易-订单处理-全部-订单作废
            TRADE_DEAL_PROCESS_MALICIOUS: 2136014, // 交易-订单处理-全部-恶意上报
            TRADE_DEAL_PROCESS_UNURGENT: 21378, // 交易-订单处理-全部-取消加急
            TRADE_DEAL_PROCESS_URGENT: 21377, // 交易-订单处理-全部-订单加急
            TRADE_DEAL_PROCESS_HALT: 21374, // 交易-订单处理-全部-订单挂起
            TRADE_DEAL_PROCESS_BATCHCOMBOTOSINGLE: 213150, // 交易-订单处理-全部-组合装转单品
            TRADE_DEAL_PROCESS_BATCHMESSAGEHANDLE: 231220, // 交易-订单处理-全部-批量处理留言
            TRADE_DEAL_PROCESS_BATCHREMARKHANDLE: 231217, // 交易-订单处理-全部-批量处理备注
            TRADE_DEAL_PROCESS_COMMON_ORDER_AND_DISTRI_ORDER_TRANSFER: 2131314, // 交易-订单处理-全部-普通⇌天猫分销
            TRADE_DEAL_PROCESS_COMMON_ORDER_PROD_TRANSFER: 2136038, // 交易-订单处理-全部-套件⇌实体商品
            TRADE_DEAL_PROCESS_BATCH_PURCHASE_ON_SALES: 213600816, // 交易-订单处理-全部-批量以销定采
            TRADE_DEAL_PROCESS_EXCEPTION_CANCEL: 213110, // 交易-订单处理-全部-取消异常
            TRADE_DEAL_PROCESS_CANCEL_INSUFFICIENT: 213108, // 交易-订单处理-全部-缺货发货
            TRADE_DEAL_PROCESS_CONTINUE_SENDGOODS: 213109, // 交易-订单处理-全部-继续发货
            TRADE_DEAL_PROCESS_MULTI_VIEW: 21347, // 交易-订单处理-全部-多快递单查看
            TRADE_DEAL_PROCESS_CANCEL_ORDER: 231306, // 交易-订单处理-全部-取消订单
            TRADE_DEAL_PROCESS_PRINT: 21394, // 交易-订单处理-全部-预览打印
            TRADE_DEAL_PROCESS_REPRINT: 213128, // 交易-订单处理-全部-重新打印
            TRADE_DEAL_PROCESS_MULTI_PRINT: 21396, // 交易-订单处理-全部-一单多包打印
            TRADE_DEAL_PROCESS_CREATE: 21366, // 交易-订单处理-全部-新建普通订单
            TRADE_DEAL_PROCESS_CREATE_CROSS: 21367, // 交易-订单处理-全部-新建跨境订单
            TRADE_DEAL_PROCESS_CREATE_SINGLE_IMPORT: 21368, // 交易-订单处理-全部-单店铺导入
            TRADE_DEAL_PROCESS_CREATE_MULTI_IMPORT: 21369, // 交易-订单处理-全部-多店铺导入
            TRADE_DEAL_PROCESS_MARK_EMPTY: 21375, // 交易-订单处理-全部-标记空单
            TRADE_DEAL_PROCESS_CANCEL_EMPTY: 21376, // 交易-订单处理-全部-取消空单
            TRADE_DEAL_PROCESS_UPDATE_TAG: 213180, // 交易-订单处理-全部-修改标签
            TRADE_DEAL_PROCESS_UPDATE_NOTE: 21379, // 交易-订单处理-全部-修改便签
            TRADE_DEAL_PROCESS_WW_MARK: 21380, // 交易-订单处理-全部-旺旺/昵称标记
            TRADE_DEAL_PROCESS_TID_MARK: 21381, // 交易-订单处理-全部-交易号标记
            TRADE_DEAL_PROCESS_UPDATE_WAREHOUSE: 21382, // 交易-订单处理-全部-修改仓库
            TRADE_DEAL_PROCESS_BATCH_UPDATE_PROD: 21383, // 交易-订单处理-全部-修改商品
            TRADE_DEAL_PROCESS_REPLACE_PROD: 231291, // 交易-订单处理-全部-批量换商品
            TRADE_DEAL_PROCESS_BATCH_ADD_PROD: 21384, // 交易-订单处理-全部-新增商品
            TRADE_DEAL_PROCESS_BATCH_DEL_PROD: 231242, // 交易-订单处理-全部-批量删除商品
            TRADE_DEAL_PROCESS_SUIT2SINGLE: 21385, // 交易-订单处理-全部-套件换单品
            TRADE_DEAL_PROCESS_UPDATE_EXPRESS: 21386, // 交易-订单处理-全部-修改快递
            TRADE_DEAL_PROCESS_UPDATE_EXPRESSID: 213165, // 交易-订单处理-全部-设置单号
            TRADE_DEAL_PROCESS_UPDATE_CIQINFO: 21387, // 交易-订单处理-全部-修改报关信息
            TRADE_DEAL_PROCESS_BATCH_VOID: 21388, // 交易-订单处理-全部-批量作废订单
            TRADE_DEAL_PROCESS_UPDATE_SYS_NOTE: 21389, // 交易-订单处理-全部-修改系统备注
            TRADE_DEAL_PROCESS_IPDATE_PLAT_NOTE: 21390, // 交易-订单处理-全部-修改平台备注
            TRADE_DEAL_PROCESS_SEND_WITHOUT_LOGISTICS: 21391, // 交易-订单处理-全部-无需物流发货
            TRADE_DEAL_PROCESS_SEND_PRINT: 21392, // 交易-订单处理-全部-打印发货
            TRADE_DEAL_PROCESS_UPLOAD_SEND: 21393, // 交易-订单处理-全部-平台打印发货
            TRADE_DEAL_PROCESS_DIRECT_SEND: 213131, // 交易-订单处理-全部-直接发货
            TRADE_DEAL_PROCESS_ONLY_SEND: 213199, // 交易-订单处理-全部-仅发货
            TRADE_DEAL_PROCESS_HANDWRITE: 21395, // 交易-订单处理-全部-手写快递
            TRADE_DEAL_PROCESS_MULTI_PACKET: 21396, // 交易-订单处理-全部-一单多包打印
            TRADE_DEAL_PROCESS_FETCH_PRINT: 21397, // 交易-订单处理-全部-拿货单打印
            TRADE_DEAL_PROCESS_IMPORT_OUTSID: 21398, // 交易-订单处理-全部-运单号导入
            TRADE_DEAL_PROCESS_SPLIT_BY_WEIGHT: 21399, // 交易-订单处理-全部-重量拆分
            TRADE_DEAL_PROCESS_SPLIT_BY_MIXED: 213100, // 交易-订单处理-全部-混合拆分
            TRADE_DEAL_PROCESS_SHOPEE_SPLIT: 231309, // 交易-订单处理-全部-shopee订单拆分
            TRADE_DEAL_PROCESS_SPLIT_BY_OUT: 213101, // 交易-订单处理-全部-缺货拆分
            TRADE_DEAL_PROCESS_SPLIT_BY_REFUND: 213102, // 交易-订单处理-全部-退款拆分
            TRADE_DEAL_PROCESS_SPLIT_BY_UNMATCHED: 213103, // 交易-订单处理-全部-未匹配拆分
            TRADE_DEAL_PROCESS_SPLIT_BY_BOX: 21301066, // 交易-订单处理-全部-默认箱规拆分
            TRADE_DEAL_PROCESS_SPLIT_BY_BATCH: 213104, // 交易-订单处理-全部-批量拆分
            TRADE_DEAL_PROCESS_MERGE_ORDER: 213105, // 交易-订单处理-全部-手工合单
            TRADE_DEAL_PROCESS_MERGE_ORDER_BY_CROSS: 213106, // 交易-订单处理-全部-快点合单
            TRADE_DEAL_PROCESS_BATCH_CANCEL_MERGE: 213107, // 交易-订单处理-全部-取消合单
            TRADE_DEAL_PROCESS_RE_SENDGOODS: 213153, // 交易-订单处理-全部-重新发货
            TRADE_DEAL_PROCESS_DELAY_CONFIRM: 213154, // 交易-订单处理-全部-延长收货时间
            TRADE_DEAL_PROCESS_CANCEL: 213110, // 交易-订单处理-全部-取消异常
            TRADE_DEAL_PROCESS_REPLACE_GOODS_EXCEPTION: 213600814, // 交易-订单处理-全部-处理换货前商品平台信息变更异常
            TRADE_DEAL_PROCESS_PLAT_CANCEL: 213111, // 交易-订单处理-全部-平台修改异常
            TRADE_DEAL_PROCESS_SWAP_STOCK: 213112, // 交易-订单处理-全部-指定库存调剂
            TRADE_DEAL_PROCESS_BATCH_SWAP_STOCK: 213113, // 交易-订单处理-全部-批量库存调剂
            TRADE_DEAL_PROCESS_SWAP_STOCK_BY_PROD: 213114, // 交易-订单处理-全部-按商品分配库存
            TRADE_DEAL_PROCESS_SINGLE_SORT: 213115, // 交易-订单处理-全部-单品排序
            TRADE_DEAL_PROCESS_MULTI_SORT: 213116, // 交易-订单处理-全部-多品排序
            TRADE_DEAL_PROCESS_SMART_AUDIT: 213138, // 交易-订单处理-全部-智能审核
            TRADE_DEAL_PROCESS_SMART_REPLACE: 213314, // 交易-订单处理-全部-智能商品搭配
            TRADE_DEAL_PROCESS_SMART_PRESELL: 213149, // 交易-订单处理-全部-智能匹配预售
            TRADE_DEAL_PROCESS_SMART_MATCH: 213117, // 交易-订单处理-全部-快递智能匹配
            TRADE_DEAL_PROCESS_SMART_PERCENT: 213119, // 交易-订单处理-全部-按比例分配快递
            TRADE_DEAL_PROCESS_MATCH_GIFT: 213120, // 交易-订单处理-全部-手工匹配赠品
            TRADE_DEAL_PROCESS_SMART_MERGE: 213121, // 交易-订单处理-全部-智能合单
            TRADE_DEAL_PROCESS_SMART_MERGE_BY_CROSS: 213122, // 交易-订单处理-全部-跨店智能合单
            TRADE_DEAL_PROCESS_SMART_TAG: 213123, // 交易-订单处理-全部-智能标签
            TRADE_DEAL_PROCESS_FX_CHECKOUT: 213124, // 交易-订单处理-全部-分销结账
            TRADE_DEAL_PROCESS_UPDATE_ORDER: 213130, // 交易-订单处理-全部-修改订单商品
            TRADE_DEAL_PROCESS_UPDATE_PRODS: 213209, // 交易-订单处理-全部-修改商品
            TRADE_DEAL_PROCESS_CHANGE_PRODS: 213206, // 交易-订单处理-全部-换商品
            TRADE_DEAL_PROCESS_UPDATE_ORDER_PRICE: 231258, // 交易-订单处理-全部-修改订单商品单价
            TRADE_DEAL_PROCESS_UPDATE_ORDER_PAY: 231259, // 交易-订单处理-全部-修改订单商品应收金额
            TRADE_DEAL_PROCESS_UPDATE_ORDER_ADDRESS: 213181, // 交易-订单处理-全部-修改订单收货地址
            TRADE_DEAL_PROCESS_UPDATE_GIFT: 213193, // 交易-订单处理-全部-管理赠品
            TRADE_DEAL_PROCESS_TURN_EXCEPTION: 213135, // 交易-订单处理-全部-转异常
            TRADE_DEAL_PROCESS_AUTO_CALC_EXCEPTION: 213137, // 交易-订单处理-全部-智能匹配异常
            TRADE_DEAL_PROCESS_SMART_WAREHOUSE: 213147, // 交易-订单处理-全部-智能分仓
            TRADE_DEAL_PROCESS_EXPORT_ORDER: 213140, // 交易-订单处理-全部-导出订单
            TRADE_DEAL_PROCESS_EXPORT_DETAIL: 213141, // 交易-订单处理-全部-导出订单明细
            TRADE_DEAL_PROCESS_CANCEL_CONSIGN: 213155, // 交易-订单处理-全部-取消发货
            TRADE_DEAL_PROCESS_STOCKOUT_ANALYSE: 213197, // 交易-订单处理-全部-缺货分析
            TRADE_DEAL_PROCESS_STOCKOUT_AUDIT: 213195, // 交易-订单处理-全部-缺货审核
            TRADE_DEAL_PROCESS_FORCE_AUDIT: 2136085, // 交易-订单处理-全部-强制审核
            TRADE_DEAL_PROCESS_HANDLEUNMATCH: 231236, // 交易-订单处理-全部-处理商品未匹配
            TRADE_DEAL_PROCESS_PAY_AUDIT: 213202, // 交易-订单处理-全部-支付单审核
            TRADE_DEAL_PROCESS_PAY_CANCEL_AUDIT: 213203, // 交易-订单处理-全部-支付单取消审核
            TRADE_DEAL_PROCESS_PAY_ADD: 213201, // 交易-订单处理-全部-添加支付单
            TRADE_DEAL_PROCESS_MATCHUP: 231234, // 交易-订单处理-全部-处理对应关系改动
            TRADE_DEAL_PROCESS_HANDLESUITINFO: 231235, // 交易-订单处理-全部-处理套件信息修改
            TRADE_DEAL_PROCESS_DCRY: 231303, // 交易-订单处理-全部-批量解密
            TRADE_DEAL_PROCESS_EDIT_DIVIDE_ORDER_FEE: 2131317, // 交易-订单处理-全部-修改商品平台实付
            TRADE_DEAL_PROCESS_PROD_TYPE_CONVERT: 2136036, // 交易-订单处理-全部-处理商品类型转换
            TRADE_DEAL_PROCESS_UPDATE_FREIGHT_INVOICE: 2136067, // 交易-订单处理-全部-修改订单运费、发票信息
            TRADE_DEAL_PROCESS_CACULATE_SINGLE_NUM: 213315, // 交易-订单处理-全部-智能计算单品数量
            TRADE_DEAL_PROCESS_RECALCULATION_SMART_MATCH_RULE: 213318, // 交易-订单处理-全部-智能自动化匹配规则
            TRADE_DEAL_PROCESS_CREATE_WORK_ORDER: 213680, // 交易-订单处理-全部-创建工单
            TRADE_DEAL_PROCESS_EDIT_CUSTOM_FILTER: 2136088, // 交易-订单处理-全部-自定义过滤条件操作权限
            TRADE_MANAGE_STOCKOUT_AUDIT: 2651, // 交易-订单管理-缺货审核
            TRADE_DEAL_CREATE_WLBNO: 213300, // 交易-订单处理-多平台获取单号
            TRADE_DEAL_PROGRESS_ORDER_GOODS_WEIGHT_VOLUME_UPDATE: 213400815, // 交易-订单处理-全部-订单商品重量/体积更新
            TRADE_DEAL_PRINT_EXPRESS_PLUS_SEND: 213301, // 交易-订单处理-多平台打印发货
            TRADE_DEAL_PRINT_SETTING: 213302, // 交易-订单处理-多平台打印发货
            TRADE_DEAL_UPDATE_SUPPLIERS: 21301067, // 交易-订单处理-批量更新供销商
            TRADE_DEAL_PROCESS_INTELLIGENT_ORDER_SPLITTING: 213319, // 交易-订单处理-智能拆单
    
            TRADE_DEAL_UNPAID: 2131, //交易-订单处理-待付款
            TRADE_DEAL_UNPAID_COPY_NEW_ORDER: 21301, //交易-订单处理-待付款-复制新建
            TRADE_DEAL_BATCH_CLOSE_ORDER: 2131031, //交易-订单处理-待付款-批量关闭
            TRADE_DEAL_UNPAID_UPDATE_TAG: 231312, //交易-订单处理-待付款-修改标签
            TRADE_DEAL_UNPAID_CLOSE_ORDER: 21302, //交易-订单处理-待付款-关闭订单
            TRADE_DEAL_UNPAID_CANCEL_ORDER: 213167, //交易-订单处理-待付款-订单作废
            TRADE_DEAL_UNPAID_MALICIOUS: 2131015, //交易-订单处理-待付款-恶意上报
            TRADE_DEAL_UNPAID_APPOINT_DOWNLOAD: 21303, //交易-订单处理-待付款-指定下载
            TRADE_DEAL_UNPAID_UPDATE_ORDER_ADDRESS: 231254, // 交易-订单处理-待付款-修改订单收货地址（运费、地址、发票）
            TRADE_DEAL_UNPAID_EDIT_CUSTOM_FILTER: 2131088, // 交易-订单处理-待付款-自定义过滤条件操作权限

            TRADE_DEAL_UNPAID_CREATE_WORK_ORDER: 2131080, //交易-订单处理-待付款-创建工单
            TRADE_DEAL_TOAUDIT: 2132, // 交易-订单处理-待审核
            TRADE_DEAL_TOAUDIT_NO_SHIPPING_MARKINGS: 2132099, // 交易-订单处理-待审核-批量标记商品无需发货
            TRADE_DEAL_TOAUDIT_EDIT_SALESMAN: 213210, // 交易-订单处理-待审核-修改业务员
            TRADE_DEAL_TOAUDIT_APPOINT_DOWNLOAD: 21304, // 交易-订单处理-待审核-指定下载
            TRADE_DEAL_TOAUDIT_AUDIT: 21305, // 交易-订单处理-待审核-审核
            TRADE_DEAL_TOAUDIT_FORCE_AUDIT: 2132085, // 交易-订单处理-待审核-强制审核
            TRADE_DEAL_TOAUDIT_CREATE: 21306, // 交易-订单处理-待审核-新建（复制新建）
            TRADE_DEAL_TOAUDIT_HALT: 21307, // 交易-订单处理-待审核-订单挂起
            TRADE_DEAL_TOAUDIT_URGENT: 21308, // 交易-订单处理-待审核-加急
            TRADE_DEAL_TOAUDIT_UPDATE_TAG: 21355, // 交易-订单处理-待审核-修改标签
            TRADE_DEAL_TOAUDIT_UPDATE_NOTE: 213190, // 交易-订单处理-待审核-修改便签
            TRADE_DEAL_TOAUDIT_BATCH_CANCEL_MERGE: 21357, // 交易-订单处理-待审核-批量取消合单
            TRADE_DEAL_TOAUDIT_SUIT2SINGLE: 21352, // 交易-订单处理-待审核-套件转换单品
            TRADE_DEAL_TOAUDIT_VOID: 21309, // 交易-订单处理-待审核-作废
            TRADE_DEAL_TOAUDIT_MALICIOUS: 2132002, // 交易-订单处理-待审核-恶意上报
            TRADE_DEAL_TOAUDIT_MERGE_ORDER: 21310, // 交易-订单处理-待审核-手工合单
            TRADE_DEAL_TOAUDIT_UPDATE_SYS_NOTE: 21311, // 交易-订单处理-待审核-修改系统备注
            TRADE_DEAL_TOAUDIT_UPDATE_ORDER: 21312, // 交易-订单处理-待审核-修改订单商品
            TRADE_DEAL_TOAUDIT_UPDATE_PRODS: 213207, // 交易-订单处理-待审核-修改商品
            TRADE_DEAL_TOAUDIT_BATCH_UPDATE_PRODS: 2132071, // 交易-订单处理-待审核-批量修改商品
            TRADE_DEAL_TOAUDIT_CHANGE_PRODS: 213204, // 交易-订单处理-待审核-换商品
            TRADE_DEAL_TOAUDIT_REPLACE_PROD: 231253, // 交易-订单处理-待审核-批量换商品
            TRADE_DEAL_TOAUDIT_DEL_ORDER: 231243, // 交易-订单处理-待审核-批量删除商品
            TRADE_DEAL_TOAUDIT_UPDATE_ORDER_ADDRESS: 213182, // 交易-订单处理-待审核-修改订单信息（运费、地址、发票）
            TRADE_DEAL_TOAUDIT_UPDATE_GIFT: 213191, // 交易-订单处理-待审核-管理赠品
            TRADE_DEAL_TOAUDIT_UPDATE_WAREHOUSE: 21313, // 交易-订单处理-待审核-修改仓库
            TRADE_DEAL_TOAUDIT_UPDATE_EXPRESS: 21314, // 交易-订单处理-待审核-修改快递
            TRADE_DEAL_TOAUDIT_UPDATE_EXPRESSID: 231228, // 交易-订单处理-待审核-设置单号
            TRADE_DEAL_TOAUDIT_BATCH_MESSAGE_HANDLE: 231219, // 交易-订单处理-待审核-批量处理留言
            TRADE_DEAL_TOAUDIT_BATCH_REMARK_HANDLE: 231216, // 交易-订单处理-待审核-批量处理备注
            TRADE_DEAL_TOAUDIT_COMMON_ORDER_AND_DISTRI_ORDER_TRANSFER: 2131315, // 交易-订单处理-待审核-普通⇌天猫分销
            TRADE_DEAL_TOAUDIT_BATCH_ORDER_PROD_TRANSFER: 2136039, // 交易-订单处理-待审核-套件⇌实体商品
            TRADE_DEAL_TOAUDIT_BATCH_PURCHASE_ON_SALES: 2136039, // 交易-订单处理-待审核-批量以销定采
            TRADE_DEAL_TOAUDIT_UPDATE_CIQ_INFO: 21342, // 交易-订单处理-待审核-修改报关信息
            TRADE_DEAL_TOAUDIT_FETCH_PRINT: 21315, // 交易-订单处理-待审核-拿货单打印
            TRADE_DEAL_TOAUDIT_EXCEL_IMPORT: 21316, // 交易-订单处理-待审核-Excel订单导入
            TRADE_DEAL_TOAUDIT_MARK_EMPTY: 21317, // 交易-订单处理-待审核-标记空单
            TRADE_DEAL_TOAUDIT_ORDER_SPLIT: 21318, // 交易-订单处理-待审核-订单拆分
            TRADE_DEAL_TOAUDIT_SHOPEE_SPLIT: 231256, // 交易-订单处理-待审核-shopee订单拆分
            TRADE_DEAL_TOAUDIT_CANCEL_ORDER: 231257, // 交易-订单处理-待审核-取消订单
            TRADE_DEAL_TOAUDIT_SMART_EXPRESS: 21341, // 交易-订单处理-待审核-智能物流
            TRADE_DEAL_TOAUDIT_SMART_AUDIT: 213139, // 交易-订单处理-待审核-智能审核
            TRADE_DEAL_TOAUDIT_SMART_REPLACE: 213312, // 交易-订单处理-待审核-智能商品搭配
            TRADE_DEAL_TOAUDIT_SMART_PRESELL: 21360, // 交易-订单处理-待审核-智能匹配预售
            TRADE_DEAL_TOAUDIT_MANUAL_MERGE: 21348, // 交易-订单处理-待审核-手工匹配赠品
            TRADE_DEAL_TOAUDIT_SMART_MERGE: 21344, // 交易-订单处理-待审核-智能合单
            TRADE_DEAL_TOAUDIT_SMART_TAG: 21359, // 交易-订单处理-待审核-智能标签
            TRADE_DEAL_TOAUDIT_SMART_WAREHOUSE: 231229, // 交易-订单处理-待审核-智能分仓
            TRADE_DEAL_TOAUDIT_UPLOAD_SEND: 21365, // 交易-订单处理-待审核-平台上传发货
            TRADE_DEAL_TOAUDIT_TURN_EXCEPTION: 213132, // 交易-订单处理-待审核-转异常
            TRADE_DEAL_TOAUDIT_WEXPRESS_SMART_PERCENT: 213152, // 交易-订单处理-待审核-按比例分配快递
            TRADE_DEAL_TOAUDIT_CROSS_SHOP_MERGE: 213150, // 交易-订单处理-待审核-跨店智能合单
            TRADE_DEAL_TOAUDIT_CROSS_SHOP_STUPID_MERGE: 213162, // 交易-订单处理-待审核-跨店合单
            TRADE_DEAL_TOAUDIT_ADD_DISTRI_PROD: 231221, // 交易-订单处理-待审核-新增分销属性
            TRADE_DEAL_TOAUDIT_CANCEL_DISTRI_PROD: 231222, // 交易-订单处理-待审核-取消分销属性
            TRADE_DEAL_TOAUDIT_FORCE_POINT_VENDOR: 231223, // 交易-订单处理-待审核-强制指定供销商
            TRADE_DEAL_TOAUDIT_PAY_AUDIT: 213002, // 交易-订单处理-待审核-支付单审核
            TRADE_DEAL_TOAUDIT_PAY_CANCEL_AUDIT: 213003, // 交易-订单处理-待审核-支付单取消审核
            TRADE_DEAL_TOAUDIT_PAY_ADD: 213001, // 交易-订单处理-待审核-添加支付单
            TRADE_DEAL_TOAUDIT_UPDATE_ORDER_PRICE: 213004, // 交易-订单处理-待审核-修改订单商品单价
            TRADE_DEAL_TOAUDIT_UPDATE_ORDER_PAY: 213005, // 交易-订单处理-待审核-修改订单商品应收金额
            TRADE_DEAL_TOAUDIT_SORT: 231255, // 交易-订单处理-待审核-相同商品排序
            TRADE_DEAL_TOAUDIT_EDIT_DIVIDE_ORDER_FEE: 2131318, // 交易-订单处理-待审核-修改商品平台实付
            TRADE_DEAL_TOAUDIT_CREATE_WORK_ORDER: 2132080, // 交易-订单处理-待审核-创建工单
            // TRADE_DEAL_TOAUDIT_DCRY: 231256, // 交易-订单处理-待审核-批量解密（跟【shopee订单拆分】重复了，要用这个权限的话重新起一个id）
            TRADE_DEAL_TOAUDIT_CACULATE_SINGLE_NUM: 213317, // 交易-订单处理-待审核-智能计算单品数量
            TRADE_DEAL_TOAUDIT_RECALCULATION_SMART_MATCH_RULE: 213318, // 交易-订单处理-待审核-智能自动化匹配规则
            TRADE_DEAL_TOAUDIT_EDIT_CUSTOM_FILTER: 2132088, // 交易-订单处理-待审核-自定义过滤条件操作权限


            TRADE_DEAL_AUDITED: 2133, // 交易-订单处理-审核记录
            TRADE_DEAL_AUDITED_TOUNAUDIT: 21319, // 交易-订单处理-审核记录-重新审核
            TRADE_DEAL_AUDITED_VOID: 21320, // 交易-订单处理-审核记录-作废
            TRADE_DEAL_AUDITED_URGENT: 21321, // 交易-订单处理-审核记录-加急
            TRADE_DEAL_AUDITED_HALT: 21322, // 交易-订单处理-审核记录-订单挂起
            TRADE_DEAL_AUDITED_FETCH_PRINT: 21323, // 交易-订单处理-审核记录-拿货单打印
            TRADE_DEAL_AUDITED_SEND_WITHOUT_LOGISTICS: 21324, // 交易-订单处理-审核记录-无需物流发货
            TRADE_DEAL_AUDITED_APPOINT_DOWNLOAD: 21340, // 交易-订单处理-审核记录-指定下载
            TRADE_DEAL_AUDITED_MULTI_VIEW: 21346, // 交易-订单处理-审核记录-多快递单查询
            TRADE_DEAL_AUDITED_IMPORT_OUTSID: 21350, // 交易-订单处理-审核记录-运单号导入
            TRADE_DEAL_AUDITED_TURN_EXCEPTION: 213133, // 交易-订单处理-审核记录-转异常
            TRADE_DEAL_AUDITED_UPDATE_FREIGHT_INVOICE: 2133067, // 交易-订单处理-审核记录-修改订单运费、发票信息
            TRADE_DEAL_AUDITED_CREATE_WORK_ORDER: 2133080, // 交易-订单处理-审核记录-创建工单
            TRADE_DEAL_AUDITED_EDIT_CUSTOM_FILTER: 2133088, // 交易-订单处理-审核记录-自定义过滤条件操作权限

            TRADE_DEAL_EXCEPTION: 2134,// 交易-订单处理-异常订单
            TRADE_DEAL_EXCEPTION_NO_SHIPPING_MARKINGS: 2134099, // 交易-订单处理-异常订单-批量标记商品无需发货
            TRADE_DEAL_EXCEPTION_APPOINT_DOWNLOAD: 21325, // 交易-订单处理-异常订单-指定下载
            TRADE_DEAL_EXCEPTION_TOUNAUDIT: 213148, // 交易-订单处理-异常订单-重新审核
            TRADE_DEAL_EXCEPTION_AUDIT: 213172, // 交易-订单处理-异常订单-审核
            TRADE_DEAL_EXCEPTION_FORCE_AUDIT: 2134085, // 交易-订单处理-异常订单-强制审核
            TRADE_DEAL_EXCEPTION_CANCEL_ORDER: 231307, // 交易-订单处理-异常订单-取消订单
            TRADE_DEAL_EXCEPTION_URGENT: 21326, // 交易-订单处理-异常订单-加急
            TRADE_DEAL_EXCEPTION_UPDATE_TAG: 21356, // 交易-订单处理-异常订单-修改标签
            TRADE_DEAL_EXCEPTION_COPY: 231308, // 交易-订单处理-异常订单-复制新建
            TRADE_DEAL_EXCEPTION_UPDATE_NOTE: 213170, // 交易-订单处理-异常订单-修改便签
            TRADE_DEAL_EXCEPTION_BATCH_CANCEL_MERGE: 21358, // 交易-订单处理-异常订单-批量取消合单
            TRADE_DEAL_EXCEPTION_SUIT2SINGLE: 21353, // 交易-订单处理-异常订单-套件转换单品
            TRADE_DEAL_EXCEPTION_BATCHCOMBOTOSINGLE: 213151, // 交易-订单处理-异常订单-组合装转单品
            TRADE_DEAL_EXCEPTION_BATCH_MESSAGE_HANDLE: 231218, // 交易-订单处理-异常订单-批量处理留言
            TRADE_DEAL_EXCEPTION_BATCH_REMARK_HANDLE: 231215, // 交易-订单处理-异常订单-批量处理备注
            TRADE_DEAL_EXCEPTION_COMMON_ORDER_AND_DISTRI_ORDER_TRANSFER: 2131316, // 交易-订单处理-异常订单-普通⇌天猫分销
            TRADE_DEAL_EXCEPTION_BATCH_ORDER_PROD_TRANSFER: 2136040, // 交易-订单处理-异常订单-套件⇌实体商品
            TRADE_DEAL_EXCEPTION_BATCH_PURCHASE_ON_SALES: 213400816, // 交易-订单处理-异常订单-批量以销定采
            TRADE_DEAL_EXCEPTION_VOID: 21327, // 交易-订单处理-异常订单-作废
            TRADE_DEAL_EXCEPTION_MERGE_ORDER: 21328, // 交易-订单处理-异常订单-手工合单
            TRADE_DEAL_EXCEPTION_UPDATE_SYS_NOTE: 21329, // 交易-订单处理-异常订单-修改系统备注
            TRADE_DEAL_EXCEPTION_UPDATE_ORDER: 21330, // 交易-订单处理-异常订单-删除订单商品
            TRADE_DEAL_EXCEPTION_UPDATE_PRODS: 213208, // 交易-订单处理-异常订单-修改商品
            TRADE_DEAL_EXCEPTION_BATCH_UPDATE_PRODS: 2134071, // 交易-订单处理-异常订单-批量修改商品
            TRADE_DEAL_EXCEPTION_CHANGE_PRODS: 213205, // 交易-订单处理-异常订单-换商品
            TRADE_DEAL_EXCEPTION_REPLACE_PROD: 231288, // 交易-订单处理-异常订单-批量换商品
            TRADE_DEAL_EXCEPTION_DEL_ORDER: 231244, // 交易-订单处理-异常订单-修改订单商品
            TRADE_DEAL_EXCEPTION_UPDATE_ORDER_ADDRESS: 213183, // 交易-订单处理-异常订单-修改订单信息（含运费、地址、发票）
            TRADE_DEAL_EXCEPTION_UPDATE_GIFT: 213192, // 交易-订单处理-异常订单-管理赠品
            TRADE_DEAL_EXCEPTION_CANCEL: 21331, // 交易-订单处理-异常订单-取消异常
            TRADE_DEAL_EXCEPTION_REPLACE_GOODS_EXCEPTION: 213400814, // 交易-订单处理-异常订单-处理换货前商品平台信息变更异常
            TRADE_DEAL_EXCEPTION_UPDATE_WAREHOUSE: 21332, // 交易-订单处理-异常订单-修改仓库
            TRADE_DEAL_EXCEPTION_UPDATE_EXPRESS: 21333, // 交易-订单处理-异常订单-修改快递
            TRADE_DEAL_EXCEPTION_UPDATE_EXPRESSID: 213166, // 交易-订单处理-异常订单-设置单号
            TRADE_DEAL_EXCEPTION_UPDATE_CIQ_INFO: 21343, // 交易-订单处理-异常订单-修改报关信息
            TRADE_DEAL_EXCEPTION_FETCH_PRINT: 21334, // 交易-订单处理-异常订单-拿货单打印
            TRADE_DEAL_EXCEPTION_MARK_EMPTY: 21335, // 交易-订单处理-异常订单-标记空单
            TRADE_DEAL_EXCEPTION_ORDER_SPLIT: 21336, // 交易-订单处理-异常订单-订单拆分
            TRADE_DEAL_EXCEPTION_SHOPEE_SPLIT: 231311, // 交易-订单处理-异常订单-shopee订单拆分
            TRADE_DEAL_EXCEPTION_BATCH_SWAP_STOCK: 21351, // 交易-订单处理-异常订单-批量库存调剂
            TRADE_DEAL_EXCEPTION_SWAP_STOCK_BY_PROD: 21354, // 交易-订单处理-异常订单-按商品分配库存
            TRADE_DEAL_EXCEPTION_SWAP_STOCK: 21337, // 交易-订单处理-异常订单-指定库存调剂
            TRADE_DEAL_EXCEPTION_CANCEL_INSUFFICIENT: 21338, // 交易-订单处理-异常订单-缺货发货
            TRADE_DEAL_EXCEPTION_CONTINUE_SENDGOODS: 21339, // 交易-订单处理-异常订单-继续发货
            TRADE_DEAL_EXCEPTION_SMART_PRESELL: 21361, // 交易-订单处理-异常订单-智能匹配预售
            TRADE_DEAL_EXCEPTION_MANUAL_MERGE: 21349, // 交易-订单处理-异常订单-手工匹配赠品
            TRADE_DEAL_EXCEPTION_SMART_MERGE: 21345, // 交易-订单处理-异常订单-智能合单
            TRADE_DEAL_EXCEPTION_SMART_AUDIT: 213171, // 交易-订单处理-异常订单-智能审核
            TRADE_DEAL_EXCEPTION_SMART_REPLACE: 213313, // 交易-订单处理-异常订单-智能商品搭配
            TRADE_DEAL_EXCEPTION_SEND_PRINT: 21362, // 交易-订单处理-异常订单-打印发货
            TRADE_DEAL_EXCEPTION_UPLOAD_SEND: 21363, // 交易-订单处理-异常订单-平台上传发货
            TRADE_DEAL_EXCEPTION_DIRECT_SEND: 213145, // 交易-订单处理-异常订单-直接发货
            TRADE_DEAL_EXCEPTION_MULTI_VIEW: 21347, // 交易-订单处理-异常订单-多快递单查看
            TRADE_DEAL_EXCEPTION_SORT: 21364, // 交易-订单处理-异常订单-相同商品排序
            TRADE_DEAL_EXCEPTION_TURN_EXCEPTION: 213134, // 交易-订单处理-异常订单-转异常
            TRADE_DEAL_EXCEPTION_AUTO_CALC_EXCEPTION: 213136, // 交易-订单处理-异常订单-智能匹配异常
            TRADE_DEAL_EXCEPTION_EXPORT_ORDER: 213142, // 交易-订单处理-异常订单-导出订单
            TRADE_DEAL_EXCEPTION_EXPORT_ORDER_DETAIL: 213143, // 交易-订单处理-异常订单-导出订单明细
            TRADE_DEAL_EXCEPTION_IMPORT_OUTSID: 213144, // 交易-订单处理-异常订单-运单号导入
            TRADE_DEAL_EXCEPTION_SMART_WAREHOUSE: 213146, // 交易-订单处理-异常订单-智能分仓
            TRADE_DEAL_EXCEPTION_CROSS_SHOP_MERGE: 213151, // 交易-订单处理-异常订单-跨店智能合单
            TRADE_DEAL_EXCEPTION_CROSS_SHOP_STUPID_MERGE: 213163, // 交易-订单处理-异常订单-跨店合单
            TRADE_DEAL_EXCEPTION_STOCKOUT_ANALYSE: 213198, // 交易-订单处理-异常订单-缺货分析
            TRADE_DEAL_EXCEPTION_STOCKOUT_AUDIT: 213196, // 交易-订单处理-异常订单-缺货审核
            TRADE_DEAL_EXCEPTION_HANDLEUNMATCH: 231239, // 交易-订单处理-异常订单-处理商品未匹配
            TRADE_DEAL_EXCEPTION_MATCHUP: 231237, // 交易-订单处理-异常订单-处理对应关系改动
            TRADE_DEAL_EXCEPTION_HANDLESUITINFO: 231238, // 交易-订单处理-异常订单-处理套件信息修改
            TRADE_DEAL_EXCEPTION_ADD_DISTRI_PROD: 231224, // 交易-订单处理-异常订单-新增分销属性
            TRADE_DEAL_EXCEPTION_CANCEL_DISTRI_PROD: 231225, // 交易-订单处理-异常订单-取消分销属性
            TRADE_DEAL_EXCEPTION_FORCE_POINT_VENDOR: 231226, // 交易-订单处理-异常订单-强制指定供销商
            TRADE_DEAL_EXCEPTION_DISTRI_PAY: 231227, // 交易-订单处理-异常订单-分销商付款
            TRADE_DEAL_EXCEPTION_RETURN_SUPPLAY_ORDER: 231281, // 交易-订单处理-异常订单-打回供销订单
            TRADE_DEAL_EXCEPTION_SUPPLY_STOCK_SPLIT: 231301, // 交易-订单处理-异常订单-供销缺货拆分
            TRADE_DEAL_EXCEPTION_SUPPLY_MIX_SPLIT: 2131313, // 交易-订单处理-全部-供销混合拆分
            TRADE_DEAL_EXCEPTION_UPDATE_ORDER_PRICE: 231245, // 交易-订单处理-异常订单-修改订单商品单价
            TRADE_DEAL_EXCEPTION_UPDATE_ORDER_PAY: 231246, // 交易-订单处理-异常订单-修改订单商品应收金额
            TRADE_DEAL_EXCEPTION_DCRY: 231305, // 交易-订单处理-异常订单-批量解密
            TRADE_DEAL_EXCEPTION_EDIT_DIVIDE_ORDER_FEE: 2131319, // 交易-订单处理-异常订单-修改商品平台实付
            TRADE_DEAL_EXCEPTION_PROD_TYPE_CONVERT: 2134036, // 交易-订单处理-异常订单-处理商品类型转换
            TRADE_DEAL_EXCEPTION_CACULATE_SINGLE_NUM: 213316, // 交易-订单处理-异常订单-智能计算单品数量
            TRADE_DEAL_EXCEPTION_RECALCULATION_SMART_MATCH_RULE: 213318, // 交易-订单处理-异常订单-智能自动化匹配规则
            TRADE_DEAL_EXCEPTION_EDIT_CUSTOM_FILTER: 2134088, // 交易-订单处理-异常订单-自定义过滤条件操作权限
            TRADE_DEAL_EXCEPTION_CREATE_WORK_ORDER: 2134080, // 交易-订单处理-异常订单-创建工单

            TRADE_DEAL_PRE_SELL_UPDATE_FREIGHT_INVOICE: 2135067, // 交易-订单处理-预售订单-修改订单运费、发票信息
            TRADE_DEAL_PRESELL_CREATE_WORK_ORDER: 2135080, // 交易-订单处理-预售订单-创建工单
            TRADE_DEAL_PRESELL_EDIT_CUSTOM_FILTER: 2135088, // 交易-订单处理-预售订单-自定义过滤条件操作权限

            TRADE_FINANCE_AUDIT: 261,// 交易-订单财审
            TRADE_FINANCE_AUDIT_FX_CHECKOUT: 26101, // 交易-订单财审-分销结账
            TRADE_FINANCE_AUDIT_UPDATE_CHECKOUT_PAYMENT: 26102, // 交易-订单财审-分销结账-修改结算金额
            TRADE_FINANCE_AUDIT_UPDATE_TAG: 26103, // 交易-订单财审-修改标签

            TRADE_PRINT: 217, // 交易-订单打印
            TRADE_PRINT_UNPRINT_APPOINT_DOWNLOAD: 21701, // 交易-订单打印-快递单未打印-指定下载
            TRADE_PRINT_UNPRINT_PRINT: 21702, // 交易-订单打印-快递单未打印-预览打印/重新打印
            TRADE_PRINT_UNPRINT_EXPRESS: 21703, // 交易-订单打印-快递单未打印-修改快递
            TRADE_PRINT_UNPRINT_EXPRESSID: 21727, // 交易-订单打印-快递单未打印-设置单号
            TRADE_PRINT_UNPRINT_VOID: 21704, // 交易-订单打印-快递单未打印-订单作废
            TRADE_PRINT_UNPRINT_HALT: 21705, // 交易-订单打印-快递单未打印-订单挂起
            TRADE_PRINT_UNPRINT_URGENT: 21706, // 交易-订单打印-快递单未打印-加急
            TRADE_PRINT_UNPRINT_HANDWRITE: 21707, // 交易-订单打印-快递单未打印-手写快递
            TRADE_PRINT_UNPRINT_SORT: 21708, // 交易-订单打印-快递单未打印-打印排序
            TRADE_PRINT_26_UPDATE_SYS_NOTE: 217130, // 交易-订单打印-快递单未打印-修改系统备注
            TRADE_PRINT_UNPRINT_SEND_WITHOUT_LOGISTICS: 21709, // 交易-订单打印-快递单未打印-无需物流发货
            TRADE_PRINT_UNPRINT_MULTI_PRINT: 21711, // 交易-订单打印-快递单未打印-一单多包打印
            TRADE_PRINT_UNPRINT_SMART_EXPRESS: 21710, // 交易-订单打印-快递单未打印-智能快递
            TRADE_PRINT_UNPRINT_TOUNAUDIT: 21718, // 交易-订单打印-快递单未打印-重新审核
            TRADE_PRINT_UNPRINT_IMPORT_OUTSID: 21719, // 交易-订单打印-快递单未打印-运单号导入
            TRADE_PRINT_UNPRINT_BATCH_MULTI_PACKET: 21723, // 交易-订单打印-快递单未打印-批量一单多包打印
            TRADE_PRINT_UNPRINT_WEXPRESS_SMART_PERCENT: 21725, // 交易-订单打印-快递单未打印-按比例分配快递
            TRADE_PRINT_UNPRINT_STOCKREGION: 21742, // 交易-订单打印-快递单未打印-分配库区
            TRADE_PRINT_UNPRINT_MERCHANT: 2176, // 交易-订单打印-快递单未打印-打印商家编码
            TRADE_PRINT_UNPRINT_DCRY: 21744, // 交易-订单打印-快递单未打印-批量解密
            TRADE_PRINT_UNPRINT_UPDATE_REMARK: 2171084, // 交易-订单打印-快递单未打印-修改平台备注

            TRADE_PRINT_SEND_APPOINT_DOWNLOAD: 217261, // 交易-订单打印-打印发货-指定下载
            TRADE_PRINT_SEND_PRINT: 217272, // 交易-订单打印-打印发货-预览打印/重新打印
            TRADE_PRINT_SEND_EXPRESS: 217283, // 交易-订单打印-打印发货-修改快递
            TRADE_PRINT_SEND_EXPRESSID: 217428, // 交易-订单打印-打印发货-设置单号
            TRADE_PRINT_SEND_VOID: 217294, // 交易-订单打印-打印发货-订单作废
            TRADE_PRINT_SEND_HALT: 217305, // 交易-订单打印-打印发货-订单挂起
            TRADE_PRINT_SEND_URGENT: 217316, // 交易-订单打印-打印发货-加急
            TRADE_PRINT_SEND_HANDWRITE: 217327, // 交易-订单打印-打印发货-手写快递
            TRADE_PRINT_SEND_SORT: 217338, // 交易-订单打印-打印发货-打印排序
            TRADE_PRINT_SEND_SEND_WITHOUT_LOGISTICS: 217349, // 交易-订单打印-打印发货-无需物流发货
            TRADE_PRINT_SEND_SMART_EXPRESS: 217351, // 交易-订单打印-打印发货-智能快递
            TRADE_PRINT_SEND_STOCKREGION: 217429, // 交易-订单打印-打印发货-分配库区
            TRADE_PRINT_SEND_TOUNAUDIT: 217373, // 交易-订单打印-打印发货-重新审核
            TRADE_PRINT_SEND_IMPORT_OUTSID: 217384, // 交易-订单打印-打印发货-运单号导入
            TRADE_PRINT_SEND_MULTI_PRINT: 217362, // 交易-订单打印-快递单未打印-一单多包打印
            TRADE_PRINT_SEND_BATCH_MULTI_PACKET: 217395, // 交易-订单打印-打印发货-批量一单多包打印
            TRADE_PRINT_SEND_WEXPRESS_SMART_PERCENT: 217417, // 交易-订单打印-打印发货-按比例分配快递
            TRADE_PRINT_SEND_RIGHT_NOW: 217406, // 交易-订单打印-打印发货-直接发货
            TRADE_PRINT_DCRY: 217430, // 交易-订单打印-打印发货-批量解密
            TRADE_PRINT_28_UPDATE_SYS_NOTE: 217530, // 交易-订单打印-打印发货-修改系统备注
            TRADE_PRINT_SEND_UPDATE_REMARK: 2175084, // 交易-订单打印-打印发货-修改平台备注
            TRADE_PRINT_CREATE_WLBNO: 21729, // 交易-订单打印-多平台获取单号
            TRADE_PRINT_PRINT_EXPRESS_PLUS: 21730, // 交易-订单打印-多平台打印快递单
            TRADE_PRINT_BATCH_MULTI_PACKET_PRINT_V2_PLUS: 21731, // 交易-订单打印-多平台批量一单多包打印
            TRADE_PRINT_PRINT_SETTING: 21732, // 交易-订单打印-多平台打印设置
            TRADE_PRINT_RESET_PRINT: 21733, // 交易-订单打印-多平台重新打印

            TRADE_PRINT_UNALLOT_TURN_EXCEPTION: 2174085, // 交易-订单打印-未分配快递-转异常
            TRADE_PRINT_UNPRINT_TURN_EXCEPTION: 2171085, // 交易-订单打印-快递单未打印-转异常
            TRADE_PRINT_SEND_TURN_EXCEPTION: 2175085, // 交易-订单打印-打印发货-转异常



            TRADE_PRINTV2: 291, // 交易-订单打印V2
            TRADE_PRINTV2_SEND_TURN_EXCEPTION: 29101085, // 交易-订单打印V2-打印发货-转异常
            TRADE_PRINTV2_SEND_EXPRESS: 2910107, // 交易-订单打印V2-打印发货-修改快递
            TRADE_PRINTV2_SEND_VOID: 2910109, // 交易-订单打印V2-打印发货-订单作废
            TRADE_PRINTV2_SEND_HALT: 2910108, // 交易-订单打印V2-打印发货-订单挂起
            TRADE_PRINTV2_SEND_HANDWRITE: 2910110, // 交易-订单打印V2-打印发货-手写快递
            TRADE_PRINTV2_SEND_SORT: 2910105, // 交易-订单打印V2-打印发货-订单排序
            TRADE_PRINTV2_SEND_SEND_WITHOUT_LOGISTICS: 2910111, // 交易-订单打印V2-打印发货-无需物流发货
            TRADE_PRINTV2_SEND_SMART_EXPRESS: 2910112, // 交易-订单打印V2-打印发货-智能快递
            TRADE_PRINTV2_SEND_STOCKREGION: 2910116, // 交易-订单打印V2-打印发货-分配库区
            TRADE_PRINTV2_SEND_TOUNAUDIT: 2910106, // 交易-订单打印V2-打印发货-重新审核
            TRADE_PRINTV2_SEND_IMPORT_OUTSID: 2910113, // 交易-订单打印V2-打印发货-运单号导入
            TRADE_PRINTV2_SEND_MULTI_PRINT: 2910114, // 交易-订单打印V2-快递单未打印-一单多包打印
            TRADE_PRINTV2_SEND_BATCH_MULTI_PACKET: 2910114, // 交易-订单打印V2-打印发货-批量一单多包打印
            TRADE_PRINTV2_SEND_WEXPRESS_SMART_PERCENT: 2910119, // 交易-订单打印V2-打印发货-按比例分配快递
            TRADE_PRINTV2_SEND_RIGHT_NOW: 2910115, // 交易-订单打印V2-打印发货-直接发货
            TRADE_PRINTV2_SEND_BATCH_ACTION: 2910117, // 交易-订单打印V2-打印发货-批量操作
            TRADE_PRINTV2_UPDATE_SYS_NOTE: 2910123, // 交易-订单打印V2-打印发货-修改系统备注
            TRADE_PRINTV2_GET_ELECTRON_SURFACE: 2910101, // 交易-订单打印V2-打印发货-获取电子面单
            TRADE_PRINTV2_PRINT_EXPRESS_ORDER: 2910102, // 交易-订单打印V2-打印发货-打印快递单
            TRADE_PRINTV2_PRINT_DELIVER: 2910103, // 交易-订单打印V2-打印发货-打印发货单
            TRADE_PRINTV2_PRINT_PICK: 2910104, // 交易-订单打印V2-打印发货-打印拣货单
            TRADE_PRINTV2_PRINT_VIP_SEND: 2910118, // 交易-订单打印V2-打印发货-打印唯品会送货单
            TRADE_PRINTV2_TRADE_PRODSUM: 2910126,// 交易-订单打印V2-订单商品汇总

            TRADE_PRINTV2_PRINT_EXPRESS_PLUS: 2910120, // 交易-订单打印V2-打印发货-多平台打印快递单
            TRADE_PRINTV2_BATCH_MULTI_PACKET_PRINT_V2_PLUS: 2910121, // 交易-订单打印V2-打印发货-批量多平台一单多包打印
            TRADE_PRINTV2_PRINT_SETTING: 2910122, // 交易-订单打印V2-打印发货-多平台打印设置
            TRADE_PRINTV2_PRINT_UPDATE_REMARK: 2910184, // 交易-订单打印V2-打印发货-修改平台备注



            TRADE_PRINT_PRINTED_APPOINT_DOWNLOAD: 21714, // 交易-订单打印-快递单打印记录-指定下载
            TRADE_PRINT_PRINTED_REPRINT: 21715, // 交易-订单打印-快递单打印记录-重新打印
            TRADE_PRINT_PRINTED_SORT: 21728, // 交易-订单打印-快递单打印记录-相同商品排序
            TRADE_PRINT_PRINTED_MULTI_PRINT: 21716, // 交易-订单打印-快递单打印记录-一单多包打印
            TRADE_PRINT_PRINTED_MULTI_VIEW: 21720, // 交易-订单打印-快递单打印记录-多快递单查询
            TRADE_PRINT_PRINTED_EXPRESS: 21722, // 交易-订单打印-快递单打印记录-修改快递
            TRADE_PRINT_PRINTED_EXPRESSID: 21726, // 交易-订单打印-快递单打印记录-设置单号
            TRADE_PRINT_PRINTED_UPDATE_ORDER: 21724, // 交易-订单打印-快递单打印记录-修改地址
            TRADE_PRINT_BATCH_APPOINT_DOWNLOAD: 21712, // 交易-订单打印-批次打印记录-指定下载
            TRADE_PRINT_BATCH_REPRINT: 21713, // 交易-订单打印-批次打印记录-预览打印/重新打印
            TRADE_PRINT_BATCH_REPRINT_EXPRESS: 21721, // 交易-订单打印-批次打印记录-修改快递


            TRADE_WAVEPRINT: 223,
            TRADE_WAVEPRINT_GENWAVE: 2231, // 波次打印-生成波次
            TRADE_WAVEPRINT_GENWAVE_AUTO_CONTROL: 22301, // 波次打印-生成波次-自动波次控制
            TRADE_WAVEPRINT_GENWAVE_EDIT: 22302, // 波次打印-生成波次-新增/编辑
            TRADE_WAVEPRINT_GENWAVE_GEN: 22303, // 波次打印-生成波次-生成波次
            TRADE_WAVEPRINT_GENWAVE_DETAIL: 22304, // 波次打印-生成波次-波次明细

            TRADE_WAVEPRINT_PRINT: 2232, // 波次打印-波次打印
            TRADE_WAVEPRINT_PRINT_CANCEL: 22305, // 波次打印-波次打印-取消波次
            TRADE_WAVEPRINT_PRINT_FINSIH: 22306, // 波次打印-波次打印-拣选完成
            TRADE_WAVEPRINT_PRINT_GIVEUP: 22323, // 波次打印-波次打印-放弃拣选
            TRADE_WAVEPRINT_PRINT_OUTSID: 22307, // 波次打印-波次打印-获取单号
            TRADE_WAVEPRINT_PRINT_CODEPRINT: 22308, // 波次打印-波次打印-编码打印
            TRADE_WAVEPRINT_PRINT_PRINT: 22309, // 波次打印-波次打印-打印
            TRADE_WAVEPRINT_PRINT_PICKPRINT: 22310, // 波次打印-波次打印-波次拿货单打印
            TRADE_WAVEPRINT_PRINT_BATCH_FINISH: 22311, // 波次打印-波次打印-批量完成
            TRADE_WAVEPRINT_PRINT_SEND: 22312, // 波次打印-波次打印-平台上传发货
            TRADE_WAVEPRINT_PRINT_UNAUDIT: 22313, // 波次打印-波次打印-重新审核
            TRADE_WAVEPRINT_PRINT_PATCH: 22314, // 波次打印-波次打印-重新分配库区
            TRADE_WAVEPRINT_ASSIGN_PICK: 22315, // 波次打印-波次打印-安排拣选员
            TRADE_WAVEPRINT_ASSIGN_SORT: 22316, // 波次打印-波次打印-安排播种员
            TRADE_WAVEPRINT_EXPORT_DETAIL: 22318, // 波次打印-波次打印-导出订单明细
            TRADE_WAVEPRINT_EXPORT_WAVE: 22324, // 波次打印-波次打印-导出波次明细
            TRADE_WAVEPRINT_PRINT_BATCH_PRINT: 22320, // 波次打印-波次打印-批量打印
            TRADE_WAVEPRINT_SEND_DIRECT: 22321, // 波次打印-波次打印-直接发货
            TRADE_WAVEPRINT_SEND_NOEXPRESS: 22326, // 波次打印-波次打印-无物流直接发货
            TRADE_WAVEPRINT_PRINT_PRINTPICK: 22322, // 波次打印-波次打印-拣货单打印
            TRADE_WAVEPRINT_EDIT_REMARK: 22325, // 波次打印-波次打印-修改备注

            TRADE_WAVEPRINT_LOG: 2235, // 波次打印-波次记录
            TRADE_WAVEPRINT_LOG_EXOPRT_DETAIL: 22319, // 波次打印-波次打印-导出订单明细
            TRADE_WAVEPRINT_LOG_EXPORT_WAVE: 22325, // 波次打印-波次打印-导出波次明细

            TRADE_WAVEPRINT_MANAGER: 2236, // 波次打印-波次管理
            TRADE_WAVEPRINT_MANAGER_CANCEL: 22365, // 波次打印-波次管理-取消波次
            TRADE_WAVEPRINT_MANAGER_FINSIH: 22366, // 波次打印-波次管理-拣选完成
            TRADE_WAVEPRINT_MANAGER_GIVEUP: 22381, // 波次打印-波次管理-放弃拣选
            TRADE_WAVEPRINT_MANAGER_OUTSID: 22367, // 波次打印-波次管理-获取单号
            TRADE_WAVEPRINT_MANAGER_CODEPRINT: 22368, // 波次打印-波次管理-编码打印
            TRADE_WAVEPRINT_MANAGER_PRINT: 22369, // 波次打印-波次管理-打印
            TRADE_WAVEPRINT_MANAGER_PICKPRINT: 22370, // 波次打印-波次管理-波次拿货单打印
            TRADE_WAVEPRINT_MANAGER_BATCH_FINISH: 22371, // 波次打印-波次管理-批量完成
            TRADE_WAVEPRINT_MANAGER_SEND: 22372, // 波次打印-波次管理-平台上传发货
            TRADE_WAVEPRINT_MANAGER_UNAUDIT: 22373, // 波次打印-波次管理-重新审核
            TRADE_WAVEPRINT_MANAGER_PATCH: 22374, // 波次打印-波次管理-重新分配库区
            TRADE_WAVEPRINT_MANAGER_PICK: 22375, // 波次打印-波次管理-安排拣选员
            TRADE_WAVEPRINT_MANAGER_SORT: 22376, // 波次打印-波次管理-安排播种员
            TRADE_WAVEPRINT_MANAGER_EXPORT_ORDER: 22377, // 波次打印-波次管理-导出订单明细
            TRADE_WAVEPRINT_MANAGER_EXPORT_WAVE: 22382, // 波次打印-波次管理-导出波次明细
            TRADE_WAVEPRINT_MANAGER_BATCH_PRINT: 22379, // 波次打印-波次管理-批量打印
            TRADE_WAVEPRINT_MANAGER_SEND_DIRECT: 22378, // 波次打印-波次管理-直接发货
            TRADE_WAVEPRINT_MANAGER_SEND_NOEXPRESS: 22384, // 波次打印-波次管理-无物流直接发货
            TRADE_WAVEPRINT_MANAGER_PRINTPICK: 22380, // 波次打印-波次管理-拣货单打印
            TRADE_WAVEPRINT_PICKERLOG_PRINT: 22380, // 波次打印-拣货单批次打印记录-重新打印
            TRADE_WAVEPRINT_MANAGER_EDIT_REMARK: 22383, // 波次打印-波次打印-修改备注
            TRADE_WAVEPRINT_WAVEPRINT_SINGLE_BATCH_PRINT: 22385, // 波次打印-波次打印(单个波次)-批量打印
            TRADE_WAVEPRINT_MANAGER_SINGLE_BATCH_PRINT: 22386, // 波次打印-波次管理(单个波次)-批量打印
            TRADE_WAVEPRINT_MANAGER_EDIT_EXPRESS: 22388, // 波次打印-波次打印-修改快递

            TRADE_PACKAGE: 218, // 交易-包装验货
            TRADE_PACKAGE_FINISH_FORCE: 21801, // 交易-包装验货-强制完成
            TRADE_PACKAGE_RESCAN: 21802, // 交易-包装验货-重新扫描
            TRADE_PACKAGE_OPEN_IDCODE: 21803, // 交易-包装验货-是否开启识别码
            TRADE_PACKAGE_VERIFYGOODS_FORCE: 21805, // 交易-包装验货-强制验货
            TRADE_PACKAGE_AUTOTAKEDELIVERY: 21836, // 交易-包装验货-验货完成自动收货
            TRADE_PACKAGE_SINGLE_VERIFY: 21833, // 交易-包装验货-单个商品的验货
            TRADE_PACKAGE_PRINT_TGA: 99999, // 交易-包装验货-打印吊牌
            TRADE_PACKAGE_WAVE_OPTION: 218101, // 交易-包装验货-波次扫码
            TRADE_PACKAGE_WAVE_BY_BUSSINE_NO_OPTION: 218102, // 交易-包装验货-扫单按波扫码

            TRADE_POSTPRINT_RESCAN: 21806, // 交易-后置打印-重新扫描
            TRADE_POSTPRINT_REPRINT: 21807, // 交易-后置打印-重新打印
            TRADE_POSTPRINT_CLOSEWAVE: 21808, // 交易-后置打印-结束波次
            TRADE_POSTPRINT_PRINT_ALL: 21809, // 交易-后置打印-全部打印
            TRADE_POSTPRINT_PRINT_PICKED: 21810, // 交易-后置打印-仅打已拣
            TRADE_POSTPRINT_OPEN_IDCODE: 21811, // 交易-后置打印-是否开启识别码
            TRADE_POSTPRINT_PRINT_CODE: 21812, // 交易-后置打印-打印商家编码
            TRADE_POSTPRINT_PRINT_MULTIPLE: 21813, // 交易-后置打印-多波次打印
            TRADE_POSTPRINT_PRINT_TGA: 21814, // 交易-后置打印-打印吊牌
            TRADE_POSTPRINT_PRINT_WATER: 21815, // 交易-后置打印-打印水洗唛
            TRADE_POSTPRINT_PRINT_DELIVER: 21816, // 交易-后置打印-打印发货单
            TRADE_POSTPRINT_PRINT_CONTINUITY: 21817, // 交易-后置打印-连打模式
            TRADE_POSTPRINT_PRINT_RECEIVE: 21832, // 交易-后置打印-快速收货后多波次打印
            TRADE_POSTPRINT_PRINT_BATCH_PRINT: 21839, // 交易-后置打印-订单列表-批次打印
            TRADE_POSTPRINT_PRINT_SPLITORDER: 218211, // 交易-后置打印-拆分订单


            TRADE_SOWPRINT_RESCAN: 21818, // 交易-播种打印-重新扫描
            TRADE_SOWPRINT_ITEM_DETAIL: 21819, // 交易-播种打印-商品明细
            TRADE_SOWPRINT_REPRINT: 21820, // 交易-播种打印-重新打印
            TRADE_SOWPRINT_PRINT_ALL: 21821, // 交易-播种打印-全部打印
            TRADE_SOWPRINT_PRINT_PART: 21822, // 交易-播种打印-拆分订单
            TRADE_SOWPRINT_SOWPRINTED: 21823, // 交易-播种打印-仅打已播
            TRADE_SOWPRINT_CLOSEWAVE: 21824, // 交易-播种打印-结束波次
            TRADE_SOWPRINT_PRINT_CODE: 21825, // 交易-播种打印-打印商家编码
            TRADE_SOWPRINT_PRINT_MULTIPLE: 21826, // 交易-播种打印-多波次打印
            TRADE_SOWPRINT_PRINT_TGA: 21827, // 交易-播种打印-打印吊牌
            TRADE_SOWPRINT_PRINT_WATER: 21828, // 交易-播种打印-打印水洗唛x
            TRADE_SOWPRINT_PRINT_DELIVER: 21829, // 交易-播种打印-打印发货单
            TRADE_SOWPRINT_PRINT_DELTAIL: 21834, // 交易-播种打印-播种商品明细
            TRADE_SOWPRINT_FINISHWAVE: 21835, // 交易-播种打印-结束播种
            TRADE_SOWPRINT_SPLITBYSKU: 218302, // 交易-播种打印-按sku拆分
            TRADE_SOWPRINT_PRINT_BATCH_PRINT: 21830, // 交易-包装验货-订单列表-批次打印

            // 组团验货
            TRADE_GROUPPRINT_RESCAN: 218601, // 交易-组团验货-重新扫描
            TRADE_GROUPPRINT_OVERWAVE: 218602, // 交易-组团验货-结束波次

            TRADE_WHOLESALE: 267, // 批发收银V1
            TRADE_WHOLESALE_OPT: 2672, // 批发配货
            TRADE_WHOLESALE_OPT_SUBMIT: 26720, // 批发配货-提交配货
            TRADE_WHOLESALE_OPT_SAVE: 26721, // 批发配货-保存



            TRADE_WHOLESALE_MONEY: 2673, // 批发收银
            TRADE_WHOLESALE_MONEY_SETTLE_ACCOUNTS: 26730, // 批发收银-结账
            TRADE_WHOLESALE_MONEY_SAVE: 26731, // 批发收银-保存
            TRADE_WHOLESALE_MONEY_OPEN_ORDER_IMMEDIATELY: 2671, // 批发收银-直接开单
            TRADE_WHOLESALE_MONEY_GOODS_SHIPPED: 26735, // 批发收银 - 出货商品
            TRADE_WHOLESALE_MONEY_GOODS_RETURN: 26736,//  批发收银 - 退货商品

            TRADE_WHOLESALE_MONEY_ORDER_GOODS_SHIPPED: 26754, // 批发收银（订单） - 出货商品
            TRADE_WHOLESALE_MONEY_ORDER_GOODS_RETURN: 26755,//  批发收银(订单) - 退货商品

            TRADE_WHOLESALE_MONEY_SELLING_PRICE:  26733, // 批发收银-批发收银-设为客户销售价
            TRADE_WHOLESALE_MONEY_ALL_SELLING_PRICE:  26734, // 批发收银-批发收银-设为整款客户销售价
            TRADE_WHOLESALE_MONEY_P_SELLING_PRICE:  26722, // 批发收银-批发配货-设为客户销售价
            TRADE_WHOLESALE_MONEY_P_ALL_SELLING_PRICE:  26723, // 批发收银-批发配货-设为整款客户销售价
            TRADE_WHOLESALE_MONEY_D_SELLING_PRICE:  26752, // 批发收银-批发收银（订单）-设为客户销售价
            TRADE_WHOLESALE_MONEY_D_ALL_SELLING_PRICE:  26753, // 批发收银-批发收银（订单）-设为整款客户销售价
            TRADE_WHOLESALE_MANAGE: 2674, // 销货单管理
            TRADE_WHOLESALE_MANAGE_PRINT_SALE_BILL: 26740, // 销货单管理-打印销货单
            TRADE_WHOLESALE_MANAGE_DOWNLOAD: 26741, // 销货单管理-导出excel
            TRADE_WHOLESALE_MANAGE_MANAGE_COLLECTION_ACCOUNT: 26742, // 销货单管理-管理收款账号
            TRADE_WHOLESALE_MANAGE_PRINT_SETTING: 26743, // 销货单管理-打印设置
            TRADE_WHOLESALE_MANAGE_CREATE_FINANCE_BILL: 26744, // 销货单管理-生成财务单据
            TRADE_WHOLESALE_MANAGE_SETTLE_ACCOUNTS_IMMEDIATELY: 26745, // 销货单管理-立即结账
            TRADE_WHOLESALE_MANAGE_DELETE: 26746, // 销货单管理-删除
            TRADE_WHOLESALE_MANAGE_SUBMIT: 26747, // 销货单管理-提交配货
            TRADE_WHOLESALE_MANAGE_SEE_CUSTOMER_DEBT: 26748, // 销货单管理-查看客户欠款

            TRADE_WHOLESALE_ORDER: 2675, // 批发收银（订单）
            TRADE_WHOLESALE_ORDER_SETTLE_ACCOUNTS: 26750, // 批发收银（订单）-结账

            TRADE_WHOLESALE_V2: 273, // 批发收银V2
            TRADE_WHOLESALE_V2_LIVE: 2730, // 现场收银
            TRADE_WHOLESALE_V2_LIVE_SETTLE_ACCOUNT: 27300, // 现场收银-结账
            TRADE_WHOLESALE_V2_LIVE_HUND_UP: 27301, // 现场收银-挂起
            TRADE_WHOLESALE_V2_LIVE_LOAD_HUND_UP: 27302, // 现场收银-加载挂起
            TRADE_WHOLESALE_V2_LIVE_GOODS_SHIPPED: 27304, // 现场收银 - 出货商品
            TRADE_WHOLESALE_V2_LIVE_GOODS_RETURN: 27305,//  现场收银 - 退货商品
            TRADE_WHOLESALE_V2_LIVE_ADD_PROD: 27306, // 现场收银-添加
            TRADE_WHOLESALE_V2_LIVE_CHANGE_PRICE: 27307, // 现场收银-改价
            TRADE_WHOLESALE_V2_LIVE_REPLACE_ALL: 27308, // 现场收银-一键替换
            TRADE_WHOLESALE_V2_LIVE_NOT_ENOUGH_STOCK_FORBID_BILL:273091, // 现场收银-库存不足允许开单
            TRADE_WHOLESALE_V2_LIVE_ADD_NEW_DISTRIBUTOR: 27309, // 批发收银V2 - 现场收银 - 新建分销商
            TRADE_WHOLESALE_V2_LIVE_IMPORT_PROD: 273092, // 批发收银V2 - 现场收银 - 导入商品


            TRADE_WHOLESALE_V2_MONEY: 2731, // 批发收银
            TRADE_WHOLESALE_V2_MONEY_SETTLE_ACCOUNT: 27310, // 批发收银-结账
            TRADE_WHOLESALE_V2_MONEY_HUND_UP: 27311, // 批发收银-挂起
            TRADE_WHOLESALE_V2_MONEY_LOAD_HUND_UP: 27312, // 批发收银-加载挂起
            TRADE_WHOLESALE_V2_MONEY_GOODS_SHIPPED: 27314, // 批发收银 - 出货商品
            TRADE_WHOLESALE_V2_MONEY_GOODS_RETURN: 27315,//  批发收银 - 退货商品
            TRADE_WHOLESALE_V2_MONEY_ADD_PROD: 27318, // 批发收银-添加
            TRADE_WHOLESALE_V2_MONEY_CHANGE_PRICE: 27316, // 批发收银-改价
            TRADE_WHOLESALE_V2_MONEY_REPLACE_ALL: 27319, // 批发收银-一键替换
            TRADE_WHOLESALE_V2_MONEY_PRE_BTN: 27327, // 结账-结账收银-预配货 按钮
            TRADE_WHOLESALE_V2_MONEY_CONFIRM_BTN: 27326, // 结账-结账收银-确认 按钮
            TRADE_WHOLESALE_V2_MONEY_DIRECT_BILLING: 27328, // 批发收银 - 收银方式 - 直接开单
            TRADE_WHOLESALE_V2_MONEY_PRE_ORDER_BILLING: 27329, // 批发收银 - 收银方式 - 预配货单结账
            TRADE_WHOLESALE_V2_MONEY_ADD_NEW_DISTRIBUTOR: 273191, // 批发收银V2 - 批发收银 - 新建分销商
            TRADE_WHOLESALE_V2_MONEY_NOT_ENOUGH_STOCK_FORBID_BILL: 273192, // 批发收银V2 - 批发收银 - 库存不足允许开单
            TRADE_WHOLESALE_V2_MONEY_IMPORT_PROD: 273193, // 批发收银V2 - 批发收银 - 导入商品

            TRADE_WHOLESALE_V2_RECORD: 2732, // 收银记录
            TRADE_WHOLESALE_V2_RECORD_PRINT_BILL: 27320, // 收银记录-打印小票
            TRADE_WHOLESALE_V2_RECORD_COMBINE_PRINT: 27325, // 收银记录-合并打印小票
            TRADE_WHOLESALE_V2_RECORD_DOWNLOAD_EXCEL: 27321, // 收银记录-导出excel
            TRADE_WHOLESALE_V2_RECORD_MANAGE_COLLECTION_ACCOUNT: 27322, // 收银记录-管理收款账号
            TRADE_WHOLESALE_V2_RECORD_PRINT_SETTING: 27323, // 收银记录-打印设置
            TRADE_WHOLESALE_V2_RECORD_SEE_DEBT: 27324, // 收银记录-查看欠款
            TRADE_WHOLESALE_V2_RECORD_DANG_KOU_ORDER_IMPORT_EXCEL: 273213, // 收银记录-档口订单导入
            TRADE_WHOLESALE_V2_RECORD_BATCH_COLLECTION: 273211, // 收银记录-收款
            TRADE_WHOLESALE_V2_RECORD_SHAN_CHU: 273217, // 收银记录-删除
            TRADE_WHOLESALE_V2_RECORD_PAY_CLEARING_RECORD: 273216, // 收银记录-收款清账记录

            TRADE_WHOLESALE_V2_LIVE_CONFIG_SETTLEMENT: 27303, // 交易-现场收银-维护结账方式
            TRADE_WHOLESALE_V2_MONEY_CONFIG_SETTLEMENT: 27313, // 交易-批发收银-维护结账方式
            TRADE_WHOLESALE_MONEY_CONFIG_SETTLEMENT: 26732, // 批发收银-维护结账方式
            TRADE_WHOLESALE_ORDER_CONFIG_SETTLEMENT: 26751, // 批发收银（订单）-维护结账方式
            TRADE_WHOLESALE_V2_RECORD_COMBINE_PRINT2: 273210, // 收银记录-合并打印小票2
            TRADE_WHOLESALE_V2_RECORD_PRINT_EXPRESS: 273212, // 收银记录-已出库打印快递单
            TRADE_WHOLESALE_V2_RECORD_BATCH_CHECKOUT: 273214, // 收银记录-批量结账
            TRADE_WHOLESALE_V2_RECORD_BALANCE_CLEAR_ACCOUNT: 273215, //  收银记录-用余额清账

            TRADE_WHOLESALE_MANAGE_PUSH_ORDER_TO_SLH: 26749, // 销货单管理-推单到商陆花

            TRADE_OUTSTOCK: 258, // 交易-待出库
            TRADE_OUTSTOCKING: 2581, // 交易-待出库
            TRADE_OUTSTOCKING_NEW: 25801, // 交易-待出库-新建
            TRADE_OUTSTOCKING_PRINT: 25802, // 交易-待出库-预览打印
            TRADE_OUTSTOCKING_SEND: 25803, // 交易-待出库-批量发货
            TRADE_OUTSTOCKING_DOWNLOAD: 25804, // 交易-待出库-指定下载
            TRADE_OUTSTOCKING_PROD_UPDATE: 25805, // 交易-待出库-修改商品
            TRADE_OUTSTOCKING_WAREHOUSE: 25806, // 交易-待出库-批量修改仓库
            TRADE_OUTSTOCKING_EXPRESS: 25807, // 交易-待出库-批量修改快递
            TRADE_OUTSTOCKING_DELETE: 25808, // 交易-待出库-批量删除
            TRADE_OUTSTOCKING_AUDIT: 25809, // 交易-待出库-批量审核
            TRADE_OUTSTOCKING_UNAUDIT: 25810, // 交易-待出库-取消审核
            TRADE_OUTSTOCKING_EXPORT: 25811, // 交易-待出库-导出订单明细
            TRADE_OUTSTOCKING_VIP: 25812, // 交易-待出库-唯品会仓库地址
            TRADE_OUTSTOCKING_SPLIT: 25813, // 交易-待出库-订单拆分
            TRADE_OUTSTOCKING_SWAP: 25814, // 交易-待出库-订单库存调剂
            TRADE_OUTSTOCKING_HANDLE_WRITE: 25819, // 交易-待出库-手写快递
            TRADE_OUTSTOCKING_CANCEL: 25820, // 交易-待出库-取消异常

            TRADE_OUTSTOCKED: 2582, // 交易-已出库
            TRADE_OUTSTOCKED_DOWNLOAD: 25816, // 交易-已出库-指定下载
            TRADE_OUTSTOCKED_EXPORT: 25818, // 交易-已出库-出库单明细导出
            TRADE_OUTSTOCKED_PRINT: 25817, // 交易-已出库-打印
            TRADE_OUTSTOCKED_VIPJIT: 25815, // 交易-已出库-查看出仓明细

            TRADE_PAY:269, //交易-支付单
            TRADE_PAY_AUDIT:269001,//交易-支付单-审核
            TRADE_PAY_AUDIT_CANCEL:269002,//交易-支付单-取消审核
            TRADE_PAY_CANCEL:269003,//交易-支付单-作废

            TRADE_VIPJIT:275,//交易-jit
            TRADE_VIPJIT_OUT:2752,//交易-jit出仓单
            TRADE_VIPJIT_PO:2751,//交易-jitPO单
            TRADE_VIPJIT_PICK:2753,//交易-jit拣选单

            TRADE_FASTOUTSTOCK: 263, // 交易-快速扫描出库
            TRADE_FASTOUTSTOCK_CASH_OUT: 26301, // 交易-快速扫描出库-现出
            TRADE_FASTOUTSTOCK_SELF_LIFT: 26302, // 交易-快速扫描出库-自提
            TRADE_FASTOUTSTOCK_POST: 26303, // 交易-快速扫描出库-邮寄

            TRADE_PICKWAVE: 257, // 波次领单
            TRADE_PICKWAVE_RESCAN: 25703, // 波次领单-重新扫描
            TRADE_PICKWAVE_BEGINPICK: 25704, // 波次领单-开始拣选
            TRADE_PICKWAVE_FINISHPICK: 25705, // 波次领单-完成拣选

            PURCHASE_ORDER: 540, // 采购-采购单管理
            PURCHASE_ORDER_AUDIT: 54001, // 审核（批量审核）
            PURCHASE_ORDER_REFUSE: 54002, // 拒绝（批量拒绝）
            PURCHASE_ORDER_CLOSE: 54003, // 关闭
            PURCHASE_ORDER_NEW: 54004, // 新建采购单
            PURCHASE_ORDER_SMART: 54005, // 智能采购单
            PURCHASE_ORDER_MODIFY: 54006, // 修改
            PURCHASE_ORDER_SUBMIT_AUDIT: 54007, // 提审
            PURCHASE_ORDER_PRINT: 54008, // 打印（采购单打印）
            PURCHASE_ORDER_PRINT_ITEMS:54017,//商品信息打印
            PURCHASE_ORDER_PRINT_GETTER: 54009, // 拿货单打印
            PURCHASE_ORDER_SPLIT_BY_SUPPLIER: 54010, // 按供销商拆分
            PURCHASE_ORDER_DETAIL: 54011, // 详情
            PURCHASE_ORDER_SMART_RULE: 54012, // 智能采购单规则
            PURCHASE_ORDER_EXPORT_EXCEL: 54013, // 导出Excel
            PURCHASE_ORDER_BATCH_SUBMIT_AUDIT: 54014, // 批量提审
            PURCHASE_ORDER_BATCH_FINISHED: 54015, // 批量完成
            PURCHASE_ORDER_BATCH_CLOSED: 54016, // 批量关闭
            PURCHASE_ORDER_BATCH_UNAUDIT: 54019,//批量打回草稿
            PURCHASE_ORDER_OPP_AUDIT: 54018, // 批量关闭
            PURCHASE_ORDER_MERGE_ORDER: 54020, // 采购合单
            PURCHASE_ORDER_FAST_AUDIT: 54021, // 快速审核

            PURCHASE_ORDER_V2: 590, // 采购单V2
            PURCHASE_ORDER_V2_EDIT_LABEL: 59001, // 修改标签

            PURCHASE_QUICK: 570, // 采购快速收货
            PURCHASE_QUICK_SET_COMPONENT: 57001, //设置成分

            PURCHASE_RETURN: 550, // 采购退货
            PURCHASE_RETURN_EDIT_LABEL: 55001, // 修改标签

            PURCHASE_RETURN_V2: 595, // 采购退货
            PURCHASE_RETURN_V2_EDIT_LABEL: 59501, // v2修改标签

            PURCHASE_RECEIPT: 511, // 采购收货
            PURCHASE_RECEIPT_EDIT_LABEL: 51115, // 待收货修改标签
            PURCHASE_RECEIPT_DONE_EDIT_LABEL: 51116, // 收货完成修改标签

            STOCK_STATU: 610, // 库存-库存状态
            STOCK_STATU_EXPORT_PROD: 61001, // 库存-按商品导出excel
            STOCK_STATU_EXPORT_STOCK: 61002, // 库存-按库存导出excel
            STOCK_STATU_PRINT_CODE: 61003, // 库存-打印编码
            STOCK_STATU_PRINT_TAG: 61004, // 库存-打印吊牌
            STOCK_STATU_PRINT_WATER: 61005, // 库存-打印水洗唛
            STOCK_STATU_SET_VIRTUAL: 61006, // 库存-虚拟库存设置
            STOCK_STATU_CLEAR_VIRTUAL: 61007, // 库存-清空虚拟库存
            STOCK_STATU_SAVE_PRICE: 61008, // 库存-清空虚拟库存


            STOCK_ALLOT: 691,// 库存-调拨单管理
            STOCK_ALLOT_CREATE: 69101, //新建调拨单
            STOCK_ALLOT_COPY_CREATE: 691011, //新建调拨单
            STOCK_ALLOT_AUDIT: 69102, //批量审核
            STOCK_ALLOT_FINISH: 69103, //手动完成
            STOCK_ALLOT_CANCEL: 69104, //作废
            STOCK_ALLOT_UPDATE: 69105, //修改调拨单
            STOCK_ALLOT_FINANCE: 69108,// 财务审核
            STOCK_ALLOT_TAG_MANAGEMENT: 691101,// 标签管理
            STOCK_ALLOT_TAG_SET: 691102,// 标签设置
            STOCK_ALLOT_EXPORT: 691012,// 导出Excel
            STOCK_ALLOT_BATCH_KEYOUT: 691103, //批量一键出库
            
            

            STOCK_ALLOT_OUT_AUDIT: 69111, //出库单审核
            STOCK_ALLOT_OUT_AUDIT_CANCEL: 69109,//出库单取消审核
            STOCK_ALLOT_OUT_BATCH_AUDIT: 69112, //出库单审核
            STOCK_ALLOT_OUT_PRINT: 69119,//批量打印
            STOCK_ALLOT_OUT_BATCH_PRINT: 69123,//批量打印
            STOCK_ALLOT_OUT_EXPORT: 69120,//导出出库明细
            STOCK_ALLOT_OUT_OUTBOUND: 69126, // 批量出库
            STOCK_ALLOT_OUT_CANCEL: 69145, // 作废
            STOCK_ALLOT_OUT_GENWAVE: 69135, // 生成波次
            STOCK_ALLOT_OUT_UPDATEPICKED: 69129, // 详情-已拣数编辑
            STOCK_ALLOT_OUT_TAG_SET: 691201,// 标签设置

            STOCK_ALLOT_IN_PRINT: 69121,//打印
            STOCK_ALLOT_IN_BATCH_PRINT: 69113,//批量打印
            STOCK_ALLOT_IN_RECEIPT: 69114, //收货
            STOCK_ALLOT_IN_BATCH_RECEIPT: 69115,//批量收货
            STOCK_ALLOT_IN_PRINT_PROD: 69116,//打印商品
            STOCK_ALLOT_IN_SHELVE: 69122,//上架
            STOCK_ALLOT_IN_BATCH_SHELVE: 69117,//批量上架
            STOCK_ALLOT_IN_EXPORT: 69118,//导出
            STOCK_ALLOT_IN_PRINT_ORDER: 69106,//打印调拨单
            STOCK_ALLOT_IN_TAG_SET: 691301,// 标签设置

            SALE_HANDLE: 425, //售后-售后工单新版
            SALE_HANDLE_SOLVE: 42501, //解决
            SALE_HANDLE_RE_SOLVE: 42502, //反解决
            SALE_HANDLE_CONFIRM_RETURN: 42503, //确认退货入仓
            SALE_HANDLE_CANCEL_RETURN: 42504, //取消退货入仓
            SALE_HANDLE_BIND_ORDER: 42505, //绑定订单
            SALE_HANDLE_CANCEL_ORDER: 42506, //作废
            SALE_HANDLE_THIRD_WAREHOUSE: 42507, //三方仓
            SALE_HANDLE_CREATE_AND_SOLVE: 42508, // 创建并解决售后工单
            SALE_HANDLE_AFTER_TYPE: 42509, //售后工单新版 -  换货,补发类型
            SALE_HANDLE_EDIT_REFUNDEXPRESSCOMPANY: 42510, //售后工单新版 - 修改退回快递
            SALE_HANDLE_EDIT_EXPRESSID: 42513, //售后工单新版 - 修改快递单号

            FAST_RETURN: 427, //售后-快速收货
            FAST_RETURN_AFTER_TYPE: 42701, //快速收货 - 换货,补发类型


            PROD_RECORD: 310, // 商品档案
            PROD_HISTORY_PRICE: 31026, // 商品档案：基本信息-维护历史成本价

            PROD_PARALLEL: 387, // 商品档案v2
            PROD_PARALLEL_IMPORT: 31012,
            PROD_PARALLEL_EXPORT: 31013,
            PROD_PARALLEL_BATCH_UPDATE: 31014,
            PROD_PARALLEL_BATCH_OPERATE: 310127, // 商品档案v2: 操作权限-批量操作
            PROD_PARALLEL_BATCH_FILL: 31015,
            PROD_PARALLEL_ITEM_DELETE: 31016,
            PROD_PARALLEL_ITEM_EDIT: 31017,
            PROD_PARALLEL_ITEM_CREATE: 31018,
            PRODV1_PARALLEL_PURCHASEPRICE_EDIT: 31022, // 商品档案: 操作权限-编辑成本价
            PRODV2_PARALLEL_PURCHASEPRICE_EDIT: 38717, // 商品档案v2: 操作权限-编辑成本价
            PRODV2_PARALLEL_SELLING_PRICE_EDIT: 38727, // 商品档案v2: 操作权限-编辑销售价
            PRODV2_PARALLEL_WHOLESALE_PRICE_EDIT: 38730, // 商品档案v2: 操作权限-编辑批发价
            PRODV2_PARALLEL_SUPPLIER_PURCHASE_PRICE_EDIT: 38731, // 商品档案v2: 操作权限-编辑进货价
            PRODV2_PARALLEL_MARKET_PRICE_EDIT: 38732, // 商品档案v2: 操作权限-编辑市场价
            PRODV2_PARALLEL_OTHER_PRICE1_EDIT: 38733, // 商品档案v2: 操作权限-编辑其他价格1
            PRODV2_PARALLEL_OTHER_PRICE2_EDIT: 38734, // 商品档案v2: 操作权限-编辑其他价格2
            PRODV2_PARALLEL_OTHER_PRICE3_EDIT: 38735, // 商品档案v2: 操作权限-编辑其他价格3
            PRODV2_PARALLEL_OTHER_PRICE4_EDIT: 38741, // 商品档案v2: 操作权限-编辑其他价格4
            PRODV2_PARALLEL_OTHER_PRICE5_EDIT: 38742, // 商品档案v2: 操作权限-编辑其他价格5
            PRODV2_PARALLEL_HISTORYPRICE_EDIT: 6727, // 商品档案v2: 操作权限-修改历史成本价
            PRODV2_PARALLEL_RELATION_WAREHOUSE_EDIT: 38725, // 商品档案v2: 操作权限-商品关联仓库
            PRODV2_PARALLEL_CROSSDECLAREAUTH: 38726, // 商品档案v2: 操作权限-跨境申报信息
            PRODV2_PARALLEL_PROD_MAPPING: 7727, // 商品档案v2: 操作权限-跨境申报信息
            PRODV2_PARALLEL_COPYCREATEPROD_OPE: 38728, // 商品档案v2: 操作权限-复制并生成
            PROD_PARALLEL_STOCK_AUTO_UPLOAD: 31020,
            PROD_PARALLEL_IMPORT_PURCHASE_PRICE: 310121,
            PROD_PARALLEL_REFRESH_PURCHASE_PRICE: 310122,

            PROD_PARALLEL_PLATFORM_INFO_CHANGE: 31019,
            // PROD_BATCH_CHANGE_BIND:34007,//商品-对应表-批量换绑(按钮)

            PROD_PARALLEL_PATCH_TAG_MANAGE: 38724, // 商品档案V2-批量设置商品标签
            PROD_PARALLEL_OPERATE_SHELFSTATUS: 31033, // 商品档案V2-上下架

            PROD_PARALLEL_PUSH_SUPPLIER: 38718, // 商品档案V2-推给供销商
            PROD_PARALLEL_RELATION_SUPPLIER: 38719, // 商品档案V2-关联供销商
            PROD_PARALLEL_TAG_MANAGE: 38720, // 商品档案V2-标签管理
            PROD_PARALLEL_PLATFORM_INFO_VIEW: 38721, // 商品档案V2-平台信息查看
            PROD_PARALLEL_OPERATE_ACTIVE: 38722, // 商品档案V2-启用
            PROD_PARALLEL_OPERATE_DEACTIVE: 38723, // 商品档案V2-停用
            PROD_PARALLEL_NEW_ADD_SUPPLIER: 31021, // 商品档案V2-新建商品-选择供销商-新增
            PROD_PARALLEL_PURCHASE_LINK: 38737, // 商品档案V2-维护采购链接
            PROD_PARALLEL_BATCH_EDIT_SUITE: 38738, // 商品档案v2-批量编辑套件商品
            PROD_PARALLEL_PROD_TYPE_CONVERT: 38739, // 商品档案v2-商品类型转换
            // 仓储
            STORAGE_WAREHOUSE: 1001,
            STORAGE_WAREHOUSE_EDIT: 1001001,
            STORAGE_WAREHOUSE_BATCH_EDIT: 1001002,
            STORAGE_WAREHOUSE_ENABLE: 1001003, // 库区货位-启用
            STORAGE_WAREHOUSE_DISABLE: 1001004, // 库区货位-禁用
            STORAGE_WAREHOUSE_BATCH_ENABLE: 1001005, // 库区货位-批量启用
            STORAGE_WAREHOUSE_BATCH_DISABLE: 1001006, // 库区货位-批量禁用
            STORAGE_WAREHOUSE_IMPORT_ACTIVE: 1001007, // 库区货位-导入启禁货位

            STORAGE_OTHER_IN: 1031, // 其他入库单
            STORAGE_OTHER_IN_ADD_ORDER: 103101, // 其他入库单-新建
            STORAGE_OTHER_IN_FINANCE_AUDIT: 103102, // 其他入库单-财务审核
            STORAGE_OTHER_IN_EDIT_ORDER: 103103, // 其他入库单-编辑
            STORAGE_OTHER_IN_AUDIT: 103104, // 其他入库单-审核
            STORAGE_OTHER_IN_CANCEL_ORDER: 103105, // 其他入库单-作废
            STORAGE_OTHER_IN_REJEC_DRAFT: 103114, // 其他入库单-打回草稿
            STORAGE_OTHER_IN_EXPORT_EXCEL: 103106, // 其他入库单-导出Excel
            STORAGE_OTHER_IN_EDIT_CUSTOM_TYPE: 103107, // 其他入库单-维护出入库类型
            STORAGE_OTHER_IN_TAG_MANAGE: 103108, // 其他入库单-标签管理
            STORAGE_OTHER_IN_SET_TAG: 103109, // 其他入库单-设置标签
            STORAGE_OTHER_IN_ADJUST_ORDER: 103110, // 其他入库单-入库调整
            STORAGE_OTHER_IN_EXAMINE_ADJUST_ORDER: 103113, // 其他入库单-审核并入库
            STORAGE_OTHER_IN_WAREHOUSING_SHELVING_ORDER: 103115, // 其他入库单-入库并上架
            STORAGE_OTHER_IN_EDITCUSTOMTYPE: 103111, // 其他入库单-编辑入库类型
            STORAGE_OTHER_IN_EDIT_DETAIL_PRICE: 103112, // 其他入库单-编辑明细单价
            STORAGE_OTHER_OUT: 1032, // 其它出库单
            STORAGE_OTHER_OUT_ADD_ORDER: 103201, // 其他出库单-新建
            STORAGE_OTHER_OUT_FINANCE_AUDIT: 103202, // 其他出库单-财务审核
            STORAGE_OTHER_OUT_EDIT_ORDER: 103203, // 其他出库单-编辑
            STORAGE_OTHER_OUT_AUDIT: 103204, // 其他出库单-审核
            STORAGE_OTHER_OUT_CANCEL_ORDER: 103205, // 其他出库单-作废
            STORAGE_OTHER_OUT_EXPORT_EXCEL: 103206, // 其他出库单-导出Excel
            STORAGE_OTHER_OUT_EDIT_CUSTOM_TYPE: 103207, // 其他出库单-维护出入库类型
            STORAGE_OTHER_OUT_GEN_WAVE: 103208, // 其他出库单-生成波次
            STORAGE_OTHER_OUT_OUT_WAREHOUSE: 103209, // 其他出库单-出库
            STORAGE_OTHER_OUT_RETURN_DRAFT: 103210, // 其他出库单-打回草稿
            STORAGE_OTHER_OUT_ADJUST_ORDER: 103215, // 其他出库单-入库调整
            STORAGE_OTHER_OUT_EDITCUSTOMTYPE: 103236, // 其他出库单-编辑出库类型
            STORAGE_OTHER_OUT_EDIT_DETAIL_PRICE: 103237, // 其他出库单-编辑出库类型

            STORAGE_REMOVE: 1006, // 移库任务
            STORAGE_REMOVE_ASSIGN: 10063, // 移库任务-分配拣选员
            STORAGE_OTHER_OUT_TAG_MANAGE: 103212, // 其他出库单-标签管理
            STORAGE_OTHER_OUT_SET_TAG: 103211, // 其他出库单-设置标签
            STORAGE_OTHER_OUT_BATCH_AUDIT: 103214, // 其他出库单-批量审核
            STORAGE_OTHER_OUT_BATCH_OUT_WAREHOUSE: 103213, // 其他出库单-批量出库

            STORAGE_TOCHECK: 1004, // 等待盘点
            STORAGE_TOCHECK_CREATE: 100412, // 等待盘点-新建盘点
            STORAGE_TOCHECK_DELETE: 100431, // 等待盘点-删除
            STORAGE_TOCHECK_BATCH_DELETE: 100432, // 等待盘点-批量删除
            STORAGE_TOCHECK_FINISH: 100441, // 等待盘点-完成
            STORAGE_TOCHECK_BATCH_FINISH: 100442, // 等待盘点-批量完成
            STORAGE_TOCHECK_BATCH_CHECK: 100462, // 等待盘点-批量审核
            STORAGE_TOCHECK_BATCH_EXPORT: 100472, // 等待盘点-批量导出
            STORAGE_CHECKED: 1004, // 盘点完成
            STORAGE_CHECKED_BATCH_EXPORT: 100429, // 盘点完成-批量导出

            // 装袋登记
            STORAGE_BAGREGISTER: 1039,
            STORAGE_BAGREGISTER_WAVECODERADIO: 103901, // 波次唯一码 radio
            STORAGE_BAGREGISTER_ORDERCODERADIO: 103902, // 订单唯一码 radio
            STORAGE_BAGREGISTER_GENECODERADIO: 103903, // 普通唯一码 radio

            AFTERSALE_SALE_WAIT: 430,       // 销退入库
            // AFTERSALE_SALE_PUT: 4302,       // 等待上架
            AFTERSALE_RECEIPT_QUICK_RECEIPT: 43001, // 销退入库-等待收货-快速收货
            AFTERSALE_RECEIPT_VOID: 43002, // 销退入库-等待收货-作废
            AFTERSALE_PUT_BATCH: 430201, // 销退入库-等待上架-批量上架
            AFTERSALE_PUT_VOID: 430203, // 销退入库-等待上架-作废
            // 包材商品
            PROD_PACKAGEM: 383, // 包材商品
            PROD_PACKAGEM_NEWLY_BUILD: 38301, // 新建包材
            PROD_PACKAGEM_BATCH_DELETE: 38302, // 批量删除
            PROD_PACKAGEM_PURCHASE: 38303, // 进货
            PROD_PACKAGEM_INVENTORY: 38304, // 盘点
            PROD_PACKAGEM_MODIFY: 38305, // 修改

            // 自动化设置 - 255
            AUTOMATION_SETTINGS: 255, // 自动化设置
            SETTINGS_WAREHOUSE_DISTRIBUTION_WAREHOUSE: 25511, // 自动化设置-自动分配仓库开关的权限编号
            SETTINGS_WAREHOUSE_BY_INVENTORY: 25512,   // 按库存自动拆单分配仓库开关的权限编号：25512
            SETTINGS_SMART_MATCH_AUTOMATIC_MATCHING_EXPRESS: 25521,   // 订单自动匹配快递开关的权限编号：25521
            SETTINGS_SMART_MATCH_FREIGHT_MATCHING: 25522,   // 运费匹配规则开关的权限编号：25522
            SETTINGS_SMART_GIFT_AUTOMATIC_MATCHING_GIFTS: 25531,   // 自动匹配赠品开关的权限编号：25531
            SETTINGS_SMART_GIFT_EXPORT_GIFT_RULE: 25532,   // 自动化设置-赠品规则-导出赠品规则权限
            SETTINGS_SMART_AUTOAUDIT_AUTOMATIC_AUDIT: 25541,   // 自动审核开关的权限编号：25541
            SETTINGS_SMART_BLACKLIST_SETTINGS: 25561,   // 黑名单设置开关的权限编号：25561
            SETTINGS_SMART_PROMISE_TIME_SETTINGS: 25591,   //  自定义订单发货的承诺时间开关的权限编号：25591
            SETTINGS_SMART_PROD_COLLOCATION_SHORTAGE_MATCHING: 25601,   //  更换商品缺货匹配商品搭配规则开关的权限编号：25601
            SETTINGS_SMART_PROD_COLLOCATION_AUTOMATIC_EXECUTION: 25602,   //  订单自动执行商品搭配规则开关的权限编号：25602
            SETTINGS_SMART_AUTOSPLIT_AUTOMATICSPLITTING: 25611,   //  自动拆单开关的权限编号：25611
            SETTINGS_SMART_FINANCE_AUDIT_OPEN: 25621,   // 开启财务审核流程开关的权限编号：25621
            SETTINGS_SMART_EXPRESS_MATCH_FORBID_RULE: 25523, // 自动化设置-快递智能匹配-快递禁发设置
            
            //打印
            PRINT_TEMPLATE: 970, //打印模版
            PRINT_TEMPLATE_SETFREIGHT: 97001, // 打印-打印模版-运费设置
        },
        /**
         * 校验是否有特定btn权限
         * @param  {String} btnPid [父级id]
         * @param  {String} btnCid [当前id]
         * @return {Boolean}        [description]
         */
        checkBtnPower: function(btnPid, btnCid){
            var btnConf = RC.user.get().buttonConf;
            if (!btnPid || !btnCid) {
                console.error('参数错误');
                return true;
            }
            if(btnCid === 99999){
                return true;
            }
            // !!避免undefined
            return !!(btnConf.hasAll || (btnConf[btnPid] && btnConf[btnCid]));
        },

        // tab权限
        TabPowerConsts:{
            PROD_BATCH_CHANGE_BIND: 34007,//商品-对应表-批量换绑(按钮->tab)
            TRADE_SEARCH_LIST: 2111, // 三个月内
            TRADE_HISTORY: 2112, // 三个月前

            TRADE_DEAL_PROCESS: 2136, // 全部
            TRADE_DEAL_UNPAID: 2131, // 待付款
            TRADE_DEAL_TOAUDIT: 2132, // 待审核
            TRADE_DEAL_AUDITED: 2133, // 审核记录
            TRADE_DEAL_EXCEPTION: 2134, // 异常
            TRADE_DEAL_PRESELL: 2135, // 预售

            TRADE_PAY: 269, // 支付单

            TRADE_DEAL_FINANCE_AUDIT: 9999, // 待财审

            TRADE_PRINT_UNALLOT: 2174, // 未分配快递
            TRADE_PRINT_UNPRINT: 2171, // 未打印快递
            TRADE_PRINT_SEND: 2175, // 未打印快递
            TRADE_PRINT_BATCH_REPRINT: 2172, // 批次打印记录
            TRADE_PRINT_REPRINT: 2173, // 快递单打印记录
            TRADE_PRINT_LATE_PLAY: 2178, // 快递补打

            TRADE_GRNWAVE: 2231, // 生成波次
            TRADE_WAVE_UNPRINT: 2232, // 波次打印
            TRADE_WAVE_MANAGER: 2236, // 波次管理
            TRADE_WAVE_BATCH_REPRINT: 2233, // 批次打印记录
            TRADE_WAVE_REPRINT: 2234, // 快递单打印记录
            TRADE_PRINTV2_BATCH_REPRINT: 29102, // V2批次打印记录
            TRADE_PRINTV2_REPRINT: 29103, // V2快递单打印记录
            TRADE_PRINTV2_LATE_PLAY: 29104, // V2快递补打
            TRADE_WAVE_LOG: 2235, // 波次记录
            TRADE_WAVE_UNIQUECODE_RECEIVE_LOG: 2237, // 唯一码收货日志
            TRADE_PICKERBATCH_LOG: 2238, // 拣货单批次打印记录

            TRADE_PACKAGE: 2181, // 包装验货
            TRADE_POST_PRINT: 2182, // 后置打印
            TRADE_SOW_PRINT: 2183, // 播种打印
            TRADE_SCAN_PRINT: 2184, // 扫描打印
            TRADE_BATCH_PRINT: 2185, // 波次批打
            TRADE_PRINT_AGAIN: 21831, // 快递转发
            TRADE_GROUP_PRINT: 2186, // 组团验货
            TRADE_WAVE_UNIQUE_CODE: 2187, // 唯一码收货登记

            TRADE_WIRELESS_PRINT: 2641,  // 无线打印
            TRADE_WIRELESS_SALE_PRINT: 2642,  // 销货单无线打印
            TRADE_WIRELESS_LABEL_PRINT: 2643,  // 箱唛打印进度
            TRADE_WIRELESS_PURCHASE_RETURN_PRINT: 2644,  // 采退单无线打印
            TRADE_WIRELESS_SALE_PRINT_LOG: 9999,  // 销货单无线打印
            TRADE_WIRELESS_OUTER_ID_PRINT: 2647, // 商家编码无线打印

            TRADE_WEIGHT: 9999, // 包裹称重-发货前
            TRADE_WEIGHT_AFTER: 9999, // 包裹称重-发货后
            TRADE_BATCH_WEIGHT: 9999, // 批量包裹称重
            TRADE_WEIGHT_ONETOMULTI: 9999, // 包裹称重-一分多称重

            TRADE_SENTDONE: 9999, // 已发货
            TRADE_FINISHED: 9999, // 交易完成
            TRADE_UPLOAD_STATUS: 9999, // 上传状态
            TRADE_UPLOAD_EXCEPTION: 9999, // 上传状态
            TRADE_CLOSURE: 9999,  // 交易关闭跟踪

            // 批发收银V1
            TRADE_WHOLESALE_OPT: 2672, // 批发配货
            TRADE_WHOLESALE_MONEY: 2673, // 批发收银
            TRADE_WHOLESALE_MANAGE: 2674, // 销货单管理
            TRADE_WHOLESALE_ORDER: 2675, // 批发收银（订单）

            // 批发收银V2
            TRADE_WHOLESALE_V2_LIVE: 2730, // 现场收银
            TRADE_WHOLESALE_V2_MONEY: 2731, // 批发收银
            TRADE_WHOLESALE_V2_RECORD: 2732, // 收银记录

            TRADE_SMART_WAREHOUSE: 2551, // 分配仓库
            TRADE_SMART_MATCH: 2552, // 快递智能匹配
            TRADE_SMART_GIFT: 2553, // 赠品规则
            TRADE_SMART_GIFT_V2: 2553, // 赠品规则V2
            TRADE_SMART_AUTO_AUDIT: 2554, // 审单规则
            TRADE_SMART_AUTO_MERGE: 2555, // 自动合单
            TRADE_SMART_BLACK_LIST: 2556, // 黑名单
            TRADE_SMART_PRESELL: 2557, // 预售设置
            TRADE_SMART_TAG: 2558, // 自动标签
            TRADE_SMART_REPLACE_PROD: 9999, // 更换商品规则
            TRADE_SMART_PROMISE_TIME: 2559, // 承诺时间设置
            TRADE_SMART_OVERTIME_WARNING: 2559, // 超时预警 --- TODO 后端给对应码
            TRADE_SMART_PROD_COLLOCATION: 2560, // 商品搭配规则
            TRADE_SMART_AUTO_SPLIT: 2561, // 自动拆分
            TRADE_FINANCIAL_AUDIT: 2562, // 财审规则
            TRADE_SMART_VIPJIT_OUT: 25631, // JIT出仓单生成规则
            TRADE_SMART_MATCH_RULE: 2563, // 自动化匹配规则

            TRADE_OUTSTOCKING: 2581, // 待出库订单
            TRADE_OUTSTOCKED: 2582, // 已出库订单
            TRADE_FASTOUTSTOCK: 9999, // 快速扫描出库

            TRADE_ELECTRON_SURFACE: 9999, // 电子面单回收-菜鸟电子面单

            TRADE_PICK_ORDER: 25701, // 订单领单
            TRADE_PICK_WAVE: 25702, // 波次领单

            PROD_SHELF_SALE:9999,   //商品-上下架-出售中的宝贝
            PROD_SHELF_WAREHOUSE:9999, //商品-上下架-仓库中的宝贝
            PROD_UPDATESYNC_REALTIVE:34002, //商品-对应表-匹配复制(按钮)
            PROD_UPDATESYNC_DOWN:34001,//商品-对应表-下载商品(按钮)
            PROD_UPDATESYNC_CHANGE:34003,//商品-对应表-换(按钮)
            PROD_UPDATESYNC_UNBIND:34005,//商品-对应表-解绑(按钮)
            PROD_UPDATESYNC_COPY:34004,//商品-对应表-复制(按钮)
            PROD_UPDATESYNC_DELETE:34006,//商品-对应表-删除(按钮)
            PROD_UPDATESYNC_UPDATE:34008,//商品-对应表-自动更新配置

            PROD_PRINT_AllPRINT:38105, //商品-商品打印-全部商品打印
            PROD_PRINT_IMPORTCODEPRINT:38102, //商品-商品打印-导入打印编码
            PROD_PRINT_ACCORDITEMPRINT:38103, //商品-商品打印-按款打印编码
            PROD_PRINT_SCREENPRINT:38104, //商品-商品打印-扫描打印
            PROD_PRINT_ARRIVALPRINT:38106, //商品-商品打印-到货打印

            // 打印TAB权限
            PRINTER_EXPRESS: 9999, // 快递模板
            PRINTER_DELIVER: 9999, // 发货单模板
            PRINTER_PICKER: 9999, // 拣货单模板
            PRINTER_FETCH: 9999, // 装箱清单模板
            PRINTER_PURCHASE: 9999, // 采购单模板
            PRINTER_PURCHASE_RETURN: 9999, // 采购退货单模板
            PRINTER_RECEIPT: 9999, // 收货单模板
            PRINTER_MERCHANTCODE: 9999, // 商家编码模板
            PRINTER_BOXCODE: 9999, // 箱规码模板
            PRINTER_TAGS: 9999, // 吊牌模板
            PRINTER_GETTER: 9999, // 拿货单模板
            PRINTER_GOODSSECTION: 9999, // 货位模板
            PRINTER_CROSSBORDER: 9999, // 跨境模板
            PRINTER_REPAIR: 9999, // 维修单模板
            PRINTER_PURCHASERETURN: 9999, //采购退货单模板
            PRINTER_SALESSLIP: 9999, //销货单模版
            PRINTER_ALLOCATEORDER: 9999, //调拨单模版

            //库存TAB权限
            STOCK_RECORDS_TYPE_1: 9999, //出入库记录-三个月内
            STOCK_RECORDS_TYPE_2: 9999, //出入库记录-三个月前
            STOCK_ALLOT_BILL: 6911,
            STOCK_ALLOT_OUT: 6912,
            STOCK_ALLOT_IN: 6913,

            //采购TAB权限
            PURCHASE_STATUS_1: 9999,//处理中
            PURCHASE_STATUS_2: 9999,//已完成
            PURCHASE_STATUS_3: 9999,//已关闭
            PURCHASE_RECEIPT_1: 5111,//待收货
            PURCHASE_RECEIPT_5: 9999,//上架单已作废
            PURCHASE_RECEIPT_2: 9999,//已完成
            PURCHASE_RECEIPT_3: 9999,//已作废
            PURCHASE_RECEIPT_4: 9999,//待上架
            PURCHASE_RECEIPT_DONE: 5112,//收货完成
            PURCHASE_RECEIPT_TORETURN_CREATE: 5114,//新建采退收货单
            PURCHASE_TORETURN: 9999,//采购退货单
            PURCHASE_RECEIPT_PACK: 59101,
            PURCHASE_REPAIR_PRINT_BOX_CODE: 59102,
            PURCHASE_BATCH_PRINT_2D_BOX_CODE: 59103,
            PURCHASE_QUICK_RETURN_1: 5700,
            PURCHASE_QUICK_RETURN_2: 5702,
            PURCHASE_QUICK_RETURN_3: 5703,

            //仓储TAB权限
            STORAGE_TOCHECK: 10041,//等待盘点
            STORAGE_CHENCKED: 10042,//盘点完成
            STORAGE_TOREMOVE: 9999,//等待移库
            STORAGE_REMOVED: 9999,//移库完成
            STORAGE_TOTETURN: 9999,//等待返库
            STORAGE_RETURNED: 9999,//返库完成

            //财务TAB权限
            FINANCE_FREIGHTBALANCE: 9999,//待结算
            FINANCE_FREIGHTBALANCE_DB: 9999,//已结算
            FINANCE_ALIPAYBILL_1: 9999,//已对账
            FINANCE_ALIPAYBILL_2: 9999,//对账失败
            FINANCE_MANAGE_TO: 9999,//待开票
            FINANCE_MANAGE_ING: 9999,//开票中
            FINANCE_MANAGE_SUCCESS: 9999,//开票成功
            FINANCE_MANAGE_FAIL: 9999,//开票失败
            FINANCE_SETTING: 9999,//开票方管理
            FINANCE_RULE: 9999,//开票规则设置
            FINANCE_TAX: 9999,//税务编码规则

            // 售后
            AFTERSALE_SALE_ORDER_UNFINISHED: 9999, // 未解决
            AFTERSALE_SALE_ORDER_FINISHED: 9999, // 已解决
            AFTERSALE_SALE_ORDER_VOID: 9999, // 已作废
            AFTERSALE_SALE_RETURN_STATUS_1: 9999, // 销退入库-等待收货
            AFTERSALE_SALE_RETURN_STATUS_3: 9999, // 销退入库-等待上架
            AFTERSALE_SALE_RETURN_STATUS_2: 9999, // 销退入库-上架完成 / 收货完成
            AFTERSALE_SALE_RETURN_STATUS_4: 9999, // 销退入库-已作废
            AFTERSALE_SALE_SMART_DISTRIBUTE: 9999, // 只能售后-已作废
            AFTERSALE_SALE_WAIT: 430,       // 销退入库

            // 基础
            BASE_POWER_STAFF: 9999, // 基础-权限-员工
            BASE_POWER_ROLE: 9999, // 基础-权限-角色
            BASE_POWER_ACCOUNT: 9999, // 基础-权限-登录账号
            BASE_SETTING_THIRD_LOG_1: 9999, // 基础-第三方数据接口-第三方数据接口
            BASE_SETTING_THIRD_LOG_2: 9999, // 基础-第三方数据接口-未同步商品
            BASE_SETTING_THIRD_LOG_3: 9999, // 基础-第三方数据接口-订单推送失败
            BASE_SETTING_THIRD_LOG_4: 9999, // 基础-第三方数据接口-匹配三方快递
            BASE_SETTING_SYSSET_TRADE: 9999, // 基础-系统设置-交易配置
            BASE_SETTING_SYSSET_STORAGE: 9999, // 基础-系统设置-仓储配置
            BASE_SETTING_SYSSET_STOCK: 9999, // 基础-系统设置-库存配置
            BASE_SETTING_SYSSET_PURCHASE: 9999, // 基础-系统设置-采购配置
            BASE_SETTING_SYSSET_AFTERSALE: 9999, // 基础-系统设置-售后配置
            BASE_SETTING_SYSSET_FINANCE: 9999, // 基础-系统设置-财务配置
            BASE_SETTING_SYSSET_PDA: 9999, // 基础-系统设置-PDA配置
            BASE_SETTING_SYSSET_THIRD: 9999, // 基础-系统设置-第三方对接
            BASE_SETTING_SYSSET_CUSTOMER: 9999, // 基础-系统设置-客户配置
            BASE_SETTING_SYSSET_SERVICE: 9999, // 基础-系统设置－客服配置
            BASE_SETTING_SYSSET_GLOBALSETTING: 9999, // 基础-系统设置－全局配置
            BASE_SETTING_SYS_PAY_1: 9999, // 基础-重置设置-重置
            BASE_SETTING_SYS_PAY_2: 9999, // 基础-重置设置-充值记录
            BASE_SETTING_SYS_PAY_3: 9999, // 基础-重置设置-扣费记录

            REPORT_GOODS_SALE:1102, //商品销量报表
            REPORT_ORDER_DAILY_SALES:1103, //订单日销量报表
            REPORT_ORDER_MONTH_SALES:1106, //订单月销量报表
            REPORT_CHECK_PERFORM:1111, //审单绩效报表
            REPORT_PICK_PERFORM:1108, //拣选绩效报表
            REPORT_PACK_PERFORM:1109, //包装绩效报表
            REPORT_WEIGH_PERFORM:1112, //称重绩效报表
            REPORT_EXPRESS:1110, //快递费用报表
        },
        /**
         * 校验tab权限
         */
        checkTabPower: function(tabId){
            var tabConf = RC.user.get().tabConf || {};
            if (!tabId) {
                console.error('参数错误');
                return true;
            }
            if(tabId === 9999){
                return true;
            }
            // !!避免undefined
            return !!(tabConf.hasAll || tabConf[tabId]);
        },
        /**
         * 校验左侧菜单权限
         */
        checkMenuPower(menuId) {
            var menuConf = RC.user.get().menuConf || [],
                menuIds = [];
            if (!menuId) {
                console.error('参数错误');
                return false;
            }
            menuConf.forEach(element => {
                var children = element.children || [];
                menuIds.push(element.id * 1);
                if (children.length) {
                    children.forEach(childElement => {
                        menuIds.push(childElement.id * 1);
                    });
                }
            });
            return menuIds.includes(menuId);
        },
        getChatConfig() {
            const oldConfig = RC.user.get('chatConfigMap') || {}; // 旧接口配置 /trade/config/info
            const newConfig = RC.user.get('tradeConfigsNew') || {}; // 新接口配置 /trade/config/new/query
            return {
                ...oldConfig,
                ...newConfig,
            };
        },
        getChatConfigByName(name) {
            const config = RC.tools.getChatConfig();
            if (config && name) {
                return config[name];
            }
        },
        /**
         * 跳转 RC 页面
         * @param {String} routeName 页面标题
         * @param {String} routePath 路由路径 如：#/smart/prod_collocation/
         */
         goRCPage(routeName, routePath) {
            // 更新Tab
            RC.pub('module.left.submenu.tocreate.tab', { name: routeName, path: routePath });
            // 更新Tab下的内容
            window.location.hash = routePath;
        },
        /**
         * 下载时,弹出去下载中心的dialog
         * @param  {String} resp [下载API得到的数据]
         */
        downloadDialog:function(resp, callback, opts={}){
            // if (!resp || !resp.data) {
            //     return;
            // }
            if (resp && ((resp.data && resp.data.result == 'success') || resp.result == 1)) {
                var goToDownloadCenter = $.dialog({
                    title: '提示',
                    content: `<div style="width: 320px;height: 50px;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                        ${opts.showResult ? `
                            <p class="mb_5">
                                <span class="fc-green pr_10">成功导出${resp.data?.sucNum || 0}</span>
                                <span class="fc-red">失败${resp.data?.errorNum || 0}</span>
                            </p>
                        ` : ''}
                        <p>导出任务已发送下载中心，请前往<a href="#/index/download_center/"  class="module-guide-link-4tab">下载中心<span style="display:none;" class="guide-icon-word">下载中心</span></a>下载</p>
                    </div>`
                }).time(0,function(){
                    var $a = $(this.DOM.content.find('a'));
                    $a.off('click').on('click', function() {
                        setTimeout(function() {
                            goToDownloadCenter.close();
                            callback && callback();
                        }, 0);
                    });
                });
            } else {
                $.dialog.custom({
                    title: '提示',
                    content: '发送失败，请重新导出!',
                    ok: false
                });
            }
        },
        /**
         * @param  {[type]} num    [导出数量]
         * @param  {[type]} params [请求参数]
         */
        commonDownloadDialog: function(num, params, isNotTotal,isExportHtml, callback, opts={}) {
            if (!num) {
                $.dialog.alert('暂无数据可导出！');
                return;
            }
            $.dialog({
                width: 400,
                title: '提示',
                content: [
                    isNotTotal ?
                    '<p class="ft_14" style="line-height:30px;">一共有 <span class="fc-red">' + num + '</span> 条记录，确定要导出excel吗？</p>' : '<p class="ft_14" style="line-height:30px;">确定要导出'+(isExportHtml? 'html' : 'excel')+'吗？</p>'
                ].join(''),
                okVal: '确定',
                ok: function() {
                    API.send_call_to_server(params, function(json) {
                        // callback && callback();
                        util.tools.downloadDialog(json, callback, opts);
                    });
                }
            });
        },
        /** 获取所有员工列表 */
        getAllStaffList(showPlaceholder = false, placeholderText = '请选择') {
            const allStaffList = [...RC?.user?.get()?.allStaffList || []];
            if (showPlaceholder) allStaffList.unshift({ id: -1, name: placeholderText });
            return allStaffList;
        },
        /**
         * 店铺名称-优先取店铺简称,无取全称
         * @param  {[object]} shop [description]
         * @return {[type]}      [description]
         */
        getShortName: function(shop) {
            var shortName = '';
            if (shop) {
                // shortName = (shop.shortTitle || shop.title || '');
                shortName = shop.title;
                if (!!shop.simpleTitleConfig && shop.shortTitle) {
                  shortName = shop.shortTitle;
                }
            }
            return shortName;
        },

        /**
         * 商品权限配置-移动加权
         * @param  {[object]} data [description] 数据配置
         *
         */
        initProd_status_config:{},
        /**
         * 商品权限配置-移动加权
         * @param  {[object]} data [description] 获取数据配置
         *
         */
        getProd_status_config:function(key){
            return this.initProd_status_config[key];
        },
        /**
         * 商品档案-扩展字段(市场价,其他价格1,其他价格2...)
         * @param  {[object]} data [description] 获取字段配置
         *
         */
        getItemExtendFieldList:{ },

        //保留n位小数
        number_fixedN:function(value,digit){
            var value = value || 0 ,digit = digit || 0;
            if (!util.tools.isNum(value)) {
                return value;
            }
            if (!util.tools.isNum(digit)) {
                return digit;
            }
            return parseFloat((parseFloat(value * 1000).toFixed(digit))/ 1000).toFixed(digit) - 0;
        },
        //清空查询条件
        clearSearch:function(){
            RayCloud.pages.setCurHash({});
        },
        /**
         * 下面是一些新的通用函数
         */

        /**
         * 判断参数是否在校验数组中
         * @param {Array} checkArr 校验数组
         * @param {any} checkItem 需要判断的内容
         */
        oneOf(checkArr = [], checkItem) {
            return checkArr.indexOf(checkItem) >= 0;
        },
        /**
         * 毫秒数转成’2019-03-20‘格式
         * @param {Number} millisecond 毫秒数
         * @param {String} divide 分隔符
         */
        millisecondToDateString(millisecond = 0, divide = '-') {
            const date = new Date(millisecond);
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const day = ('0' + date.getDate()).slice(-2);
            return year + divide + month + divide + day;
        },
        /**
         * 生成旺旺呼起链接， 图片链接
         * @param string wangwangNick 旺旺名称
         */
        getWangwangLink(wangwangNick, genImg, data) {
            wangwangNick = wangwangNick || '';
            if(wangwangNick === ''){
                return '';
            }
            if(genImg){ // 旺旺图片
                return 'resources/css/build/images/icon_wangwang.gif';
            } else {
                if (data?.source === 'fxg') { // 抖音 呼起飞鸽
                    return `https://im.jinritemai.com/pc_seller_v2/main/workspace?fromOrder=${data.tid}`;
                } else { // 淘系
                    return 'https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=' + wangwangNick + '&site=cntaobao';
                }
            }
        },
        /**
         * 对昵称进行解密之后，再唤起旺旺
         * @param {string} userId 用户id
         * @param {string} openUid 买家id
         * @param {string} sid 系统id
         * @param {string} nick buyerNick
         */
        async decodeNickToWangWang(userId, openUid, sid, nick = '', is1688) {
            // 如果后端返回的 openUid 和 nick 交换了，前端这里做下处理，又交换回来。
            if (nick.length >= 24) openUid = nick;

            // 通过 openUid 获取解密后的 nick，然后开始点亮旺旺
            return new Promise((resolve) => {
                if (!is1688) {
                    // 如果 nick 没有脱敏，则可以直接唤起旺旺
                    if (!nick.includes('*') && nick.length < 24) {
                        resolve(nick);
                        return;
                    }
                    if (!openUid) {
                        RC.showWarn('订单买家ID为空，不能唤起旺旺');
                        resolve(null);
                        return;
                    }
                    // 淘宝解密方法，nick 传不传无所谓，主要传 openUid 即可.
                    let url = `https://amos.alicdn.com/getRealCid.aw?fromId=cntaobao&charset=utf-8&&source=light&client=false&bizType=1&bizDomain=taobao`;
                    url += `&toId=cntaobao${nick}&encryptToUid=${openUid}&appKey=23204092`;
                    function cb() {
                        console.log('nick脱敏后名称：', window.realcid);
                        resolve(window.realcid);
                    }
                    try {
                        // 用淘宝的唤起方法，发现有问题，所以看了一下它的源码，然后采用这种方法来获取淘宝天猫的脱敏昵称，以便唤起旺旺
                        KISSY.getScript(url, cb, "utf-8");
                    } catch {
                        resolve(null);
                    }
                } else {
                    API.get({ url: '/trade/openuid/transform', userId, openUid, sid })
                    .then(({result, data}) => {
                        if (result === 1) {
                            const { buyerNick } = data;
                            resolve(buyerNick);
                        } else {
                            RC.showWarn('旺旺唤起失败，请重新唤起');
                            resolve(null);
                        }
                    });
                }
            });
        },
        /**
         * 获取拼多多客服工作台地址(网页版)
         * @param {string} tid 平台id
         * @returns 拼多多客服工作台地址
         */
        getPddWebServiceUrl(tid) {
            return 'https://mms.pinduoduo.com/chat-merchant/index.html?orderSn=' + tid;
        },
        /**
         * 获取拼多多客服工作台地址(客户端)
         * @param {string} taobaoId 店铺在平台编号
         * * @param {string} tid 平台id
         * @returns 拼多多客服工作台地址
         */
        getPddClientServiceUrl({taobaoId,tid}) {
            // return `pddim://mms.pinduoduo.com/chat-windows/index.html?uid=${userId}&ordersn=${tid}`;
            return `pddim://pddim:sendmsg/?OpeId=open_order&mallcsid=cs_${taobaoId}&ordersn=${tid}`;
        },
        /**
         * 获取飞鸽链接
         * @param {string} sid
         * @returns
         */
        getFeigeUrl(tid) {
            if (tid && tid.includes('A')) {
                tid = tid.replace('A', '');
            }
            return `http://im.jinritemai.com/pc_seller_v2/main/workspace?fromOrder=${tid}`;
        },
        /**
         * 获取旺旺图标
         */
        getWangWangImg() {
            return 'resources/css/build/images/icon_wangwang.gif';
        },
        // 组装呼起旺旺的数据
        wangWangDataToString(data) {
            const { buyerNick, openUid = '', userId, sid, tid, shopSource, taobaoId } = data;
            return `${buyerNick},${openUid},${userId},${sid},${tid},${shopSource},${taobaoId}`;
        },
        // 将标签上呼起旺旺的数据转换为对象
        wangWangDataToObj(data) {
            if (typeof data === 'object') return data;
            const list = data?.split(',') || [];
            return {
                buyerNick: list[0],
                openUid: list[1],
                userId: list[2],
                sid: list[3],
                tid: list[4],
                shopSource: list[5],
                taobaoId: list[6],
            };
        },
        async lightWangWang(spanEle) {
            const initWangwang = ()=> {
                const Light = window['Light'];
                if(typeof(Light?.light) === 'function') {
                    Light.light(spanEle);
                    return true;
                }
                return false;
            };
            if(!(initWangwang())) {
                initWangwang();
            }
        },
        // 使用官方旺旺
        createElementWangWang(data){
            data = util.tools.wangWangDataToObj(data);
            let nick = data.buyerNick;
            let { openUid = '', shopSource } = data;
            if (nick.length >= 24) openUid = nick;
            const is1688 = shopSource === '1688';
            // 1688 需要解密，走老版本解密逻辑
            if (is1688) {
                util.tools.openWangWang(data);
                return;
            }
            // 需要呼起旺旺的用户 nick，如果 data-encode 为 true，则会对 nick 做一次 decode
            const bizdomain =  is1688 ? 'cbu' : 'taobao';
            const appKey = util.tools.getTbAppKey();
            const divEle = document.createElement('div');
            if(!openUid) {
                RC.showWarn('订单openUid为空，不能呼起旺旺');
                return;
            }
            $(divEle).html(`<span class="J_WangWang" data-sceneparam="{"toRole":"buyer","bizRef": 1}" data-biztype="1" data-appKey="${appKey}" data-display="inline" data-encryptuid="${openUid}" data-bizdomain="${bizdomain}" data-icon="small"></span>`);
            util.tools.lightWangWang(divEle);
            $(divEle).find('.ww-light a')[0].click();
            $(divEle).remove();
        },
        /**
         * 唤起旺旺/飞鸽
         * @param {object} data 订单数据
         */
        async openWangWang(data) {
            data = util.tools.wangWangDataToObj(data);
            let nick = data.buyerNick;
            const { openUid = '', taobaoId, sid, tid, shopSource, } = data;
            const is1688 = shopSource === '1688';
            const isDouyin = shopSource === 'fxg';
            const isPDD = shopSource === 'pdd';
            const _tid = util.tools.getTid(shopSource, tid);
            if(isPDD) { // 拼多多客服工作台
                window.open(`${util.tools.getPddClientServiceUrl({tid: _tid, taobaoId})}`);
                return;
            }
            if (isDouyin) { // 抖音的直接唤起飞鸽
                window.open(`${util.tools.getFeigeUrl(_tid)}`);
                return;
            }
            // 淘宝天猫/1688 的需要先对昵称解密，然后再唤起旺旺
            const buyerNick = await util.tools.decodeNickToWangWang(userId, openUid, sid, nick, is1688);
            if (!buyerNick) return;
            nick = buyerNick;

            let ua = navigator.userAgent.toLowerCase();
            let isEdge = (ua.indexOf('edge') != -1) || (ua.indexOf('edg') != -1);
            let url = '';
            if(isEdge) {
                if(nick?.includes('cntaobao')){
                    nick = nick.replace('cntaobao', '');
                }
                url = `https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=${nick}&site=cntaobao`;
            } else {
                url = `aliim:sendmsg?site=cntaobao&status=1&touid=${nick?.includes('cntaobao') ? nick : 'cntaobao' + nick}`;
            }
            const aEl = document.createElement('a');
            if(isEdge){
                aEl.target = "_blank";
            }
            aEl.href = url;
            aEl.click();
        },
        // 获取店铺图标、名称
        getShopName(userId = '') {
            const bindShops = RC.user.get('bindShops') || [];
            const shop = bindShops.find(item => item.userId == userId);
            if (!shop) return '';
            const shopTitle = this.getShortName(shop);
            return `
                <span class="shop-icon-name" userid=${shop.userId}>
                    <span class="shop-${shop.source}">${shop.flag}</span>
                    ${shopTitle}
                </span>
            `;
        },
        // 金额精度转换
        floatPrecision(number) {
            return +((+number).toFixed(2));
        },
        /**
         * created by caisc 2021-04-15
         * 扫描枪扫描商品条码的过程中，可能会因为操作不当同时录入多个商品编码导致库存无法对上
         * @param {*} code 条码
         * @param {*} unmatchFlag 不需要匹配随机码格式，⚠️生效前提：公司在白名单内
         */
        filterProductBarCode(code, unmatchFlag = false) {
            const companyId = RC.user.get('companyId');
            // 【俊欧服饰-暮云】pda，pc扫描条形码支持截取 0/1开头则截取前九位 且条码字符长度为13
            const startStrList = ['0', '1'];
            const startStr = code ? code.slice(0, 1) : '';
            // 10438.咖啡测试3 32974.俊欧服饰
            if (code.length === 13 && [32974, 10438].includes(companyId) && startStrList.includes(startStr)) {
                return code.slice(0, 9);
            }
            // 开启防重扫功能后，原有商家编码的基础上会拼上关键字 %2c + 随机码（5位随机字母）
            var keywords = '%2c';
            if (code.indexOf(keywords) === -1) {
                return code;
            }
            // 白名单公司列表 24682.钻顶贸易有限公司 9673.咖啡 10438.咖啡测试3
            // 10438
            const whiteList = [24682, 9673];
            var splitCode = code.split(keywords);
            if (unmatchFlag && whiteList.includes(companyId)) {
                return splitCode[0];
            }
            // 只有防重功能开启后拼接的随机码为5位字母，有特殊场景随机码是数字
            var Regx = /^[A-Za-z]{5}$/;
            if (Regx.test(splitCode[1])) {
                return splitCode[0];
            }
            return code;
        },
        /**
         * created by caisc 2021-04-21
         * 京东快递单号特殊处理
         * 背景：京东系快递可能存在字母单的情况，单号形式：JDXXXXXX-1-3-
         * (-1-3-)这一段为我们需要截取的部分，「-1指的是在这个快递单中，这是第几个子包裹」「-3表示这个快递单中共有3个子包裹」
         */
        filterJDExpressNumber(str) {
            var lastIndex = str.lastIndexOf('-');
            // 判断字符串最后一位是否为-
            if ((str.length - 1) !== lastIndex) {
                return str;
            }
            // 若符合上述条件，则截取掉表示「字母单」详细内容的部分
            var firstIndex = str.indexOf('-');
            return str.slice(0, firstIndex);
        },
        /**
         * 获取淘宝，天猫appkey
         * @param string
         */
        getTbAppKey() {
            let appKey = '23204092';
            if (RC.user.get()){
                appKey = RC.user.get().tbAppKey ? RC.user.get().tbAppKey : '23204092';
            }
            return appKey;
        },
        /**
         * 对象深拷贝方法
         */
        objectDeepClone(obj) {
            const _this = this;
            let newObj = new obj.constructor();
            // if (obj === null) return null
            // if (obj.constructor === Date) return obj
            // if (obj.constructor === RegExp) return obj

            for (let key in obj) {
                if(obj.hasOwnProperty(key)) {
                    const typeOfObject = Object.prototype.toString.call(obj[key]);
                    if (typeOfObject.slice(8, typeOfObject.length - 1) === 'Object') {
                        newObj[key] = _this.objectDeepClone(obj[key]);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
            return newObj;
            var firstIndex = str.indexOf('-');
            return str.slice(0, firstIndex);
        },
        //智齿客服,auto，是否自动加载
        zcInit(noName, auto = false){
            return new Promise((resolve,reject)=>{
                (function(w, d, e, x) {
                    w[e] = function() {
                        w.cbk = w.cbk || [];
                        w.cbk.push(arguments);
                    };
                    x = d.createElement('script');
                    x.async = true;
                    x.id = 'zhichiScript';
                    // x.className = 'js-call-zhichi-btn'; //该class绑定到自定义按钮上 第一步
                    x.className = 'kefu-zc'; //该class绑定到自定义按钮上 第一步
                    x.src =
                        'https://superboss.sobot.com/chat/frame/v2/entrance.js?sysnum=d72c6fcf932140b98a3d0c03ad223f68';
                    x.onload = function(){
                        resolve();//不能保证智齿加载完成
                    };
                    x.onerror = function(err){
                        reject(err);
                    };
                    d.body.appendChild(x);
                })(window, document, 'zc');
                zc('config', {
                    manual: noName ? false : !auto && true, //手动加载
                    custom: true,
                    color: '2695fa',
                    uname: noName ? '未登录' : `${RC.user.get().companyName} ${RC.user.get().nick} 【${['按时间付费','按单付费','安装费'][RC.user.get().orderType]}】`
                });
            });
        },
        /** 获取功能白名单 */
        getFeatureWhiteList() {
            return RC.user.get().featureCodes || [];
        },
        /**
         * 是否有指定功能的白名单权限
         * @param {string} key 功能白名单字段名字
         */
        hasFeaturePermission(key = '') {
            const whiteList = RC.tools.getFeatureWhiteList();
            return !!~whiteList.indexOf(key);
        },
        // 是否有自动化匹配规则的白名单权限
        hasSmartMatchRuleWhite() {
            const { TabPowerConsts, checkTabPower } = RC.tools;
            const hasPower = checkTabPower(TabPowerConsts.TRADE_SMART_MATCH_RULE);
            return RC.tools.hasFeaturePermission('smartMatchRule') && hasPower;
        },
        /**
         * 特殊字符转译
         * @param {*} str
         * @returns
         */
        characterTranslate: function(str) {
            const RexStr = /\<|\>|\"|\'|\&|　| \//g;
            str = str.replace(RexStr, function(MatchStr) {
                switch (MatchStr) {
                    case "<":
                        return "&lt;";
                        break;
                    case ">":
                        return "&gt;";
                        break;
                    case "\"":
                        return "&quot;";
                        break;
                    case "'":
                        return "&#39;";
                        break;
                    case "&":
                        return "&amp;";
                        break;
                    case " ":
                        return "&ensp;";
                        break;
                    case "　":
                        return "&emsp;";
                        break;
                    case "/":
                            return "/";
                            break;
                    default:
                        break;
                    }
                }
            );
            return str;
        },
        /**
         * 全选/全不选 工具方法
         * @param {string} checkContainer 父容器
         * @param {string} checkAllClass 选中全部 class
         * @param {string} checkSingleClass 选中单个 class
         */
        checkAllAction(checkContainer, checkAllClass, checkSingleClass) {
            checkContainer.off('ifClicked.checkAllClick');
            checkContainer.off('ifChanged.checkSingleChanged');
            checkContainer.on('ifClicked.checkAllClick', checkAllClass, function(e) {
                const target = $(e.target);
                const isPreChecked = target.prop('checked');
                checkContainer.find(checkSingleClass).iCheck(!isPreChecked ? 'check' : 'uncheck');
                setTimeout(() => target.iCheck(!isPreChecked ? 'check' : 'uncheck'));
            });
            checkContainer.on('ifChanged.checkSingleChanged', checkSingleClass, function(e) {
                const allTotal = checkContainer.find(checkSingleClass).get().length;
                const checkedTotal = checkContainer.find(`${checkSingleClass}:checked`).get().length;
                checkContainer.find(checkAllClass).iCheck(allTotal === checkedTotal ? 'check' : 'uncheck');
            });
        },
        /**
         * 复制文本
         * @param {String} copyText 需要复制的内容
         */
         copyText(copyText, tips) {
            // navigator clipboard 需要 https 等安全上下文, 否则会报错
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(copyText)
                    .then(() => {
                        tips && $.dialog.showSuccess(tips, 0.5);
                    })
                    .catch(err => {
                        console.error('复制失败：', err);
                    });
            } else {
                const input = document.createElement('input');
                document.body.appendChild(input);
                input.setAttribute('value', copyText);
                input.select();
                if (document.execCommand('copy')) {
                    document.execCommand('copy');
                    input.remove();
                    tips && $message.success(tips);
                }
            }
        },
        /**
         * 获取两个时间的差
         * @param startTime 开始时间
         * @param endTime 结束时间
         * @returns {string}
         */
        getTimeDiff (startTime, endTime) {
            let _startTime = new Date(startTime); // 开始时间
            let _endTime = new Date(endTime); // 结束时间
            let usedTime = _endTime - _startTime; // 相差的毫秒数
            let days = Math.floor(usedTime / (24 * 3600 * 1000)); // 计算出天数
            let level = usedTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
            let hours = Math.floor(level / (3600 * 1000)); // 计算剩余的小时数
            let level2 = level % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
            let minutes = Math.floor(level2 / (60 * 1000)); // 计算剩余的分钟数
            let level3 = level % (60 * 1000); // 计算剩余小时后剩余的毫秒数
            let times = Math.floor(level3 / 1000); // 计算剩余的秒
            return days + '天' + hours + '时' + minutes + '分' + times + '秒';
        },
        /**
         *
         * @param {String} select class字符串
         * @param {String} position
         * beforeBegin：对象的开始标签之前 afterBegin：对象的开始标签之后 beforeEnd：对象的结束标签之前 afterEnd：对象的结束标签之后
         */
        copyTool(select, id, position='afterEnd') {
            const oId = document.getElementById(id);
            const selectDom = oId.getElementsByClassName(select);
            console.log(selectDom);
            if(!selectDom) {
                return;
            }
            selectDom.forEach(item => {
                const targets = item.parentNode.getElementsByClassName('icon-file-copy');
                if (!targets.length) {
                    const icon = document.createElement('i');
                    icon.classList.add('iconfont', 'icon-file-copy');
                    item.insertAdjacentElement(position, icon);
                    icon.addEventListener('click', e => {
                        e.stopPropagation();
                        const span = document.createElement('span');
                        span.innerHTML = item.innerHTML;
                        document.body.appendChild(span);
                        const selection = window.getSelection();
                        const range = document.createRange();
                        range.selectNode(span);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        document.execCommand('copy', false);
                        span.remove();
                        $.dialog.showSuccess('复制成功！');
                    });
                }
            });
        },
        /*
         * 取到每个模板的id 例如：订单管理--trade_toaudit_21
         */
        getCurrentPageDomId(){
            let pageInfo = RC.pages._fn_act_get_hashs();
            let modulesId = `${pageInfo.root}.${pageInfo.app}`;
            let modulesInfo = RC.modules.get(`${modulesId}`) || {};
            let domId = "";
            if(modulesInfo.domPageId){
                domId = modulesInfo.domPageId;
            }else if(typeof modulesInfo._elm_dom_root == "string"){
                domId = modulesInfo._elm_dom_root;
            }else if(typeof modulesInfo._elm_dom_root == "object"){
                domId = $(modulesInfo._elm_dom_root).attr("id");
            }

          if($(`${domId}`).length){
            return domId;
          }

          return '#main';
        },
        /**
         * 动态获取双击表格头部排序的topic
         */
        getDynamicDblClickSortTopic() {
            let pageInfo = RC.pages._fn_act_get_hashs();
            let modulesId = pageInfo.app ? `${pageInfo.root}.${pageInfo.app}` : `${pageInfo.root}`;
            return 'global.table.header.sort.' + modulesId;
        },
        // 
        /*
         * 单位转化，并处理双精度问题 
         * val输入的内容
         * defaultId 选中的单位
         * unitList  单位list
         * conversionFactor 换算系数
         * type  1正算数量 2反算辅助数量
         */
        getUnitConversion(val = 0, defaultId, unitList = [],conversionFactor = 1, type = 1) {
            let afterVal = type == 2? val:0;
            let beforeVal = type == 1? val:0;
            let unit = {};
            unitList.forEach(item => {
                if (item.id == defaultId) {
                    conversionFactor = item.conversionFactor;
                    unit = item;
                }
            });
            val = Math.round(val * 10000);
            if (type == 1) {
                afterVal = parseFloat((val * conversionFactor) / 100);
                afterVal = Math.round(afterVal)/100;
                beforeVal = Math.round(beforeVal * 10000)/10000;
            } else {
                beforeVal = Math.round(val / conversionFactor)/10000;
            }
            return {
                afterVal,conversionFactor,pass: Math.floor(afterVal) === afterVal,unit,beforeVal
            };
        },
        /*
         * 商品拆分成单品，并组合成mini/list接口
         * model的数据{goodNum：良品数量，badNum：次品数量}
         */
        async getShopSplit(ids, model, fn, pararms={}){
            const json = await API.send_call_to_server({
                url: '/caigou/item/suits',
                type: 'post',
                itemKeys: ids
            });
            let childModel = {};
            let childIds = [];
            json.data.forEach(item => {
                let suits = item.suits || [];
                suits.forEach(item2 => {
                    if (childModel[item2.itemKey]) {
                        let goodNum = childModel[item2.itemKey].goodNum;
                        let defectiveNum = childModel[item2.itemKey].defectiveNum;
                        childModel[item2.itemKey] = {
                            goodNum: (goodNum * 1 || 0) + (model[item.itemKey].goodNum * 1 || 0) * item2.ratio * 1,
                            defectiveNum: (defectiveNum * 1 || 0) + (model[item.itemKey].defectiveNum * 1 || 0) * item2.ratio * 1,
                        };
                    } else {
                        childModel[item2.itemKey] = {
                            goodNum: (model[item.itemKey].goodNum || 0) * item2.ratio * 1,
                            defectiveNum: (model[item.itemKey].defectiveNum || 0) * item2.ratio * 1,
                        };
                        childIds.push(item2.outerId);
                    }
                });
                if (suits.length == 0) {
                    if (childModel[item.itemKey]) {
                        let goodNum = childModel[item.itemKey].goodNum;
                        let defectiveNum = childModel[item.itemKey].defectiveNum;
                        childModel[item.itemKey] = {
                            goodNum: (goodNum * 1 || 0) + (model[item.itemKey].goodNum * 1 || 0) * 1,
                            defectiveNum: (defectiveNum * 1 || 0) + (model[item.itemKey].defectiveNum * 1 || 0) * 1,
                        };
                    } else {
                        childModel[item.itemKey] = {
                            goodNum: (model[item.itemKey].goodNum || 0),
                            defectiveNum: (model[item.itemKey].defectiveNum || 0),
                        };
                        childIds.push(item.outerId);
                    }
                }
            });
            const json2 = await API.send_call_to_server({
                url: '/item/v2/mini/list',
                type: 'post',
                skuOutIdType: 1,
                ...pararms,
                tileSkuOuterId: childIds.toString()
            });
            fn(json2.data.list || [], childModel);
        },
        /** 根据图片字节流获取图片 url */
        getImageUrlByBytes(data, mimeType = 'image/png') {
            const bytes = new Uint8Array(data);
            return URL.createObjectURL(new Blob([bytes.buffer], { type: mimeType }));
        },
        /** 根据图片 url 下载该图片 */
        downloadImageByUrl(url, downloadName = '', needRelease = false) {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', downloadName);
            document.body.appendChild(link);
            link.click();
            window.setTimeout(() => {
                // 是否需要释放 URL 对象内存
                needRelease && URL.revokeObjectURL(url);
                link && document.body.removeChild(link);
            }, 0);
        },
        getUUID(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [],
                i;
            radix = radix || chars.length;
            if (len) {
                for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
            } else {
                var r;
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | (Math.random() * 16);
                        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
                    }
                }
            }
            return uuid.join('');
        },
        validatePhone(phone) {
            const reg = new RegExp(/^1[0-9]{10}$/);
            return reg.test(phone);
        },
        pubTrackName(trackName) {
            // RC.pub('control.util.behaviors.monitor', {
            //     trackName: trackName,
            //     actionType: 'click',
            // });
        },
        toFixedNoTrailingZeros(num, precision) {
            if(num) {
                // 使用toFixed保留指定的小数位，并处理可能的科学记数法
                let result = num.toFixed(precision).replace(/(\d)\.?0+$/, '$1');
                // 如果结果是整数，去除小数点
                if (result.indexOf('.') === -1) {
                    result = result.replace('.00', ''); // 特殊情况处理，如0.00
                }
                return result;
            } else {
                return '';
            }
            
        },
        /**
         * 获取当前用户是否有供分销业务
         * @returns 'fx': 分销业务 | 'gx': 供销业务 | 'gfx': 供分销业务 | false: 无供分销业务
         */
        getBusinessGFX() {
            const businessConfig = window.FE_GLOBAL_CONF.get().businessConfig;
            if (!businessConfig) {
                console.warn('未获取到业务配置');
                return 'gfx'; // 全放开
            }
            const existSupplyAndDistributionRelationship = businessConfig.existSupplyAndDistributionRelationship;
            if (existSupplyAndDistributionRelationship === 1) {
                return 'fx';
            } else if (existSupplyAndDistributionRelationship === 2) {
                return 'gx';
            } else if (existSupplyAndDistributionRelationship === 3) {
                return 'gfx';
            } else {
                return false;
            }
        },
        /**
         * 获取当前用户是否有分仓业务
         * @returns true: 存在 ｜ false: 不存在
         */
        getBusinessFC() {
            const businessConfig = window.FE_GLOBAL_CONF.get().businessConfig;
            if (!businessConfig) {
                console.warn('未获取到业务配置');
                return true; // 全放开
            }
            const activateWarehouse = businessConfig.activateWarehouse;
            return activateWarehouse === 1;
        },
        /**
        * 获取当前用户是否有带三方仓
        * @returns true: 存在 ｜ false: 不存在
        */
       getBusinessSFC() {
           const businessConfig = window.FE_GLOBAL_CONF.get().businessConfig;
           if (!businessConfig) {
               console.warn('未获取到业务配置');
               return true; // 全放开
           }
           const activateParty3Warehouse = businessConfig.activateParty3Warehouse;
           return activateParty3Warehouse === 1;
       },
        /**
         * 获取当前用户是否有财务审核业务
         * @returns true: 存在 ｜ false: 不存在
         */
        getBusinessCWSH() {
            const businessConfig = window.FE_GLOBAL_CONF.get().businessConfig;
            if (!businessConfig) {
                console.warn('未获取到业务配置');
                return true; // 全放开
            }
            const openFinancialAudit = businessConfig.openFinancialAudit;
            return openFinancialAudit === 1;
        },
        /**
         * 获取当前用户是否开启波次业务
         * @returns true: 存在 ｜ false: 不存在
         */
        getBusinessBC() {
            const businessConfig = window.FE_GLOBAL_CONF.get().businessConfig;
            if (!businessConfig) {
                console.warn('未获取到业务配置');
                return true; // 全放开
            }
            const openWave = businessConfig.openWave;
            return openWave === 1;
        },
        /**
         * 获取当前用户是否有唯品会业务
         * @returns true: 存在 ｜ false: 不存在
         */
        getBusinessWPH() {
            const businessConfig = window.FE_GLOBAL_CONF.get().businessConfig;
            if (!businessConfig) {
                console.warn('未获取到业务配置');
                return true; // 全放开
            }
            const hasJITShop = businessConfig.hasJITShop;
            return hasJITShop === 1;
        },
        /**
         * 获取当前用户是否有唯一码业务
         * @returns true: 存在 ｜ false: 不存在
         */
        getBusinessWYM() {
            const businessConfig = window.FE_GLOBAL_CONF.get().businessConfig;
            if (!businessConfig) {
                console.warn('未获取到业务配置');
                return true; // 全放开
            }
            const openUniqueCodeBusiness = businessConfig.openUniqueCodeBusiness;
            return openUniqueCodeBusiness === 1;
        },
        async showCommonConfirm(msg, title = '提示', okText = '确定', cancelText = '取消') {
            return await new Promise(resolve => {
				window.Vue.prototype.$confirm(msg, title, {
                    confirmButtonText: okText,
                    cancelButtonText: cancelText,
                    type: 'warning',
                }).then(() => resolve(true)).catch(() => resolve(false));
			});
        },
        // 截取调单号末尾的-1-1-2
        getTid(source, tid) {
            if(!tid) return tid;
            const [ a, b ] = (tid + '').split('-');
            if(source == 'pdd') return a + '-' + b; // 拼多多单号本身带有-
            return a;
        }
    }

 
    RC.util = util;
    window.RayCloud = window.RC = RC;
}

export default {
    init
}
